// ===================== contactsData.js =====================
// Centralized contact data for multiple cities in the same structure.
// Add more cities by following the same nested shape.
export const CONTACTS = {
  // Key format: "state/city" (lowercase, spaces replaced with dashes)
  "ca/dana-point": {
    city: "Dana Point",
    state: "California",
    sections: [
      {
        category: "City Hall",
        items: [
          {
            name: "City of Dana Point",
            address: "33282 Golden Lantern, Dana Point, CA 92629",
            phone: "(949) 248-3500",
            website: "https://www.danapoint.org/",
            map: "https://maps.google.com/?q=33282+Golden+Lantern,+Dana+Point,+CA+92629",
            people: [
              { title: "City Manager", name: "Michael Killebrew", phone: "(949) 248-3513", email: "mkillebrew@danapoint.org" },
              { title: "City Clerk", name: "Shayna Sharke", phone: "(949) 248-3501", email: "ssharke@danapoint.org" },
              { title: "Community Development (Interim)", name: "Jeff Rosaler", phone: "(949) 248-3560", email: "jrosaler@danapoint.org" },
              { title: "Building Official", name: "Jess McCloskey", phone: "(949) 248-3545", email: "jmccloskey@danapoint.org" },
              { title: "Chief Building Inspector", name: "Gregg Gallegos", phone: "(949) 248-3526", email: "ggallegos@danapoint.org" },
              { title: "Permit Technician", name: "Judith (Judy) Figueroa", phone: "(949) 248-3547", email: "jfigueroa@danapoint.org" },
              { title: "Senior Permit Technician", name: "John Williams", phone: "(949) 248-3594", email: "jwilliams@danapoint.org" }
            ]
          }
        ]
      },
      {
        category: "Police Services",
        items: [
          {
            name: "OCSD — Dana Point Police Services",
            address: "33282 Golden Lantern, Suite 140, Dana Point, CA 92629",
            phone: "(949) 770-6011 (Non‑Emergency), (949) 248-3531 (Local)",
            website: "https://www.ocsheriff.gov/patrol-areas/dana-point",
            map: "https://maps.google.com/?q=33282+Golden+Lantern,+Suite+140,+Dana+Point,+CA+92629",
            notes: "Captain / Chief of Police Services: Frank Gonzalez"
          }
        ]
      },
      {
        category: "Library",
        items: [
          {
            name: "Dana Point Library (OC Public Libraries)",
            address: "33841 Niguel Road, Dana Point, CA 92629",
            phone: "(949) 496-5517",
            email: "ocpl.danapoint@occr.ocgov.com",
            website: "https://ocpl.org/libraries/dana-point",
            map: "https://maps.google.com/?q=33841+Niguel+Road,+Dana+Point,+CA+92629"
          }
        ]
      },
      {
        category: "Public School",
        items: [
          {
            name: "Richard Henry Dana Elementary School",
            address: "24242 La Cresta Dr., Dana Point, CA 92629-2561",
            phone: "(949) 496-5784",
            principal: "Kristin Nelson",
            email: "knelson@capousd.org",
            website: "https://rhed-capousd-ca.schoolloop.com/",
            map: "https://maps.google.com/?q=24242+La+Cresta+Dr,+Dana+Point,+CA+92629"
          },
          {
            name: "Dana Hills High School",
            address: "33333 Golden Lantern, Dana Point, CA 92629",
            phone: "(949) 496-6666",
            attendance: "(949) 493-7685",
            website: "https://danahills.capousd.org/",
            map: "https://maps.google.com/?q=33333+Golden+Lantern,+Dana+Point,+CA+92629"
          }
        ]
      },
      {
        category: "Private",
        items: [
          {
            name: "Monarch Bay Montessori Academy",
            address: "32920 Pacific Coast Hwy, Dana Point, CA 92629",
            phone: "(949) 240-3344",
            map: "https://maps.google.com/?q=32920+Pacific+Coast+Hwy,+Dana+Point,+CA+92629"
          },
          {
            name: "St. Edward the Confessor Parish School",
            address: "33866 Calle La Primavera, Dana Point, CA 92629-2020",
            phone: "(949) 496-1241",
            principal: "Suzanne Edwards",
            email: "sedwards@stedschool.org",
            website: "https://stedschool.org/",
            map: "https://maps.google.com/?q=33866+Calle+La+Primavera,+Dana+Point,+CA+92629"
          }
        ]
      }
    ]
  },
  "ca/laguna-beach": {
    city: "Laguna Beach",
    state: "California",
    sections: [
     
      {
  category: "City Council",
  items: [
    {
      name: "Laguna Beach City Council",
      address: "505 Forest Avenue, Laguna Beach, CA 92651",
      phone: "(949) 497-3311",
      website: "https://www.lagunabeachcity.net/government/departments/city-council",
      people: [
        { title: "Mayor", name: "Alex Rounaghi" },
        { title: "Mayor Pro Tem", name: "Mark Orgill" },
        { title: "Councilmember", name: "Bob Whalen" },
        { title: "Councilmember", name: "Sue Kempf" },
        { title: "Councilmember", name: "Hallie Jones" }
      ],
      note: "Laguna Beach City Council members are elected at-large to four-year terms."  
    }
  ]
},
      {
        category: "City Clerk",
        items: [
          {
            name: "City Clerk’s Office",
            address: "505 Forest Avenue, Laguna Beach, CA 92651",
            contact: "Ann Marie McKay (City Clerk): (949) 497-0309; Deputy Cheryl Baldridge: (949) 497-0302",
            phone: "(949) 497-0705 (main)",
            fax: "(949) 497-0771",
            website: "https://www.lagunabeachcity.net/government/departments/city-clerk",
          },
        ],
      },
      {
        category: "Police Services",
        items: [
          {
            name: "Laguna Beach Police Department",
            address: "505 Forest Ave, Laguna Beach, CA 92651",
            phone: "(949) 497-0701 (Non‑Emergency)",
            website: "https://www.lagunabeachcity.net/government/departments/police",
            map: "https://maps.google.com/?q=505+Forest+Ave,+Laguna+Beach,+CA+92651"
          }
        ]
      },
      {
        category: "Library",
        items: [
          {
            name: "Laguna Beach Library (OC Public Libraries)",
            address: "363 Glenneyre St, Laguna Beach, CA 92651",
            phone: "(949) 497-1733",
            website: "https://ocpl.org/libraries/laguna-beach",
            map: "https://maps.google.com/?q=363+Glenneyre+St,+Laguna+Beach,+CA+92651"
          }
        ]
      },
      {
        category: "Public Schools (Laguna Beach Unified School District)",
        items: [
          {
            name: "Laguna Beach Unified School District (District Office)",
            address: "550 Blumont Street, Laguna Beach, CA 92651",
            phone: "(949) 497-7700",
            superintendent: "Dr. Jason Viloria",
            website: "https://www.lbusd.org",
            map: "https://maps.google.com/?q=550+Blumont+Street,+Laguna+Beach,+CA+92651",
          },
          {
            name: "Laguna Beach High School",
            address: "625 Park Avenue, Laguna Beach, CA 92651",
            phone: "(949) 497-7750",
            grades: "9–12",
            website: "https://lbhs.lbusd.org",
            principal: "Jason Allemann",
          },
          {
            name: "Thurston Middle School",
            address: "301 Helix Street, Laguna Beach, CA 92651",
            phone: "(949) 497-7700", // district phone general fallback
            grades: "7–8",
          },
          {
            name: "El Morro Elementary School",
            address: "2300 El Morro, Laguna Beach, CA 92651",
            phone: "(949) 497-7700",
            grades: "TK–6",
          },
          {
            name: "Top of the World Elementary School",
            address: "949 High Drive, Laguna Beach, CA 92651",
            phone: "(949) 497-7700",
            grades: "TK–6",
          },
          {
            name: "Laguna College of Art & Design (Higher Education)",
            address: "374 Ocean Avenue, Laguna Beach, CA 92651",
            phone: "(949) 376-6000",
            website: "https://www.lcad.edu",
          },
        ],
      },
    ]
  },
  "ca/irvine": {
    city: "Irvine",
    state: "CA",
    sections: [
      {
  category: "City Council",
  items: [
    {
      name: "Irvine City Council",
      address: "1 Civic Center Plaza, Irvine, CA 92606",
      phone: "(949) 724-6000",
      website: "https://www.cityofirvine.org/city-council",
      hours: "Mon–Thu 7:30 a m – 5:30 p m; Fri 8 a m – 5 p m",
      map: "https://maps.google.com/?q=1+Civic+Center+Plaza,+Irvine,+CA+92606",
      people: [
        { title: "Mayor", name: "Larry Agran", district: "At-Large" },
        { title: "Vice Mayor", name: "James Mai", district: "District 3" },
        { title: "Councilmember", name: "Melinda Liu", district: "District 1" },
        { title: "Councilmember", name: "William Go", district: "District 2" },
        { title: "Councilmember", name: "Mike Carroll", district: "District 4" },
        { title: "Councilmember", name: "Betty Martinez Franco", district: "District 5" },
        { title: "Councilmember", name: "Kathleen Treseder", district: "At-Large" }
      ],
      note: "Irvine recently transitioned to a seven-member council with district-based elections."  
    },{
            name: "Irvine Mayor’s Office",
            address: "1 Civic Center Plaza, Irvine, CA 92606",
            phone: "(949) 724-6233",
          },
  ]
},
      {
        category: "Police Services",
        items: [
          {
            name: "Irvine Police Department",
            address: "1 Civic Center Plaza, Irvine, CA 92606",
            chief: "Chief Michael Kent",
            website: "http://www.cityofirvine.org/irvine-police-department",
            map: "https://maps.google.com/?q=1+Civic+Center+Plaza,+Irvine,+CA+92606",
          },
        ],
      },
      {
        category: "Libraries",
        items: [
          {
            name: "Heritage Park Regional Library / University Park Library / Katie Wheeler Library (OC Public Libraries)",
            address: "Various locations in Irvine, CA",
            note: "Heritage serves as regional reference; University Park has large Chinese collection; Katie Wheeler is historic building",
            system: "Irvine shares OC Public Libraries system",
            website: "https://ocpl.org/libraries",  // general landing
          },
        ],
      },
      {
        category: "Education",
        items: [
          {
            name: "University of California, Irvine",
            address: "Irvine, CA 92697",
            phone: "(949) 824-5011",
            website: "https://uci.edu/",
            map: "https://maps.google.com/?q=Irvine,+CA+92697",
          },
        ],
      },
      {
        category: "Public Education (Irvine Unified School District)",
        items: [
          {
            name: "Irvine Unified School District (District Office)",
            address: "5050 Barranca Parkway, Irvine, CA 92604",
            phone: "(949) 936-5000",
            website: "https://iusd.org",
            note: "Serves over 38,000 TK-12 students across ~24 elementary, 5 K-8, 6 middle, 5 high schools, plus virtual programs"  
          },
          {
            name: "University High School (9-12)",
            address: "4771 Campus Drive, Irvine, CA 92612",
            phone: "(949) 936-7600",
            principal: "Michael Georgino",
            website: "https://universityhigh.iusd.org",
            note: "Comprehensive high school, nationally ranked, strong arts & athletics"  
          }
        ]
      },
      {
        category: "Elementary / Middle Schools (IUSD)",
        items: [
          {
            name: "Select Elementary Schools",
            list: [
              "Culverdale",
              "Cypress Village",
              "Deerfield",
              "Eastshore",
              "Eastwood",
              "Greentree",
              "Loma Ridge",
              "Meadow Park",
              "Northwood",
              "Oak Creek",
              "Portola Springs",
              "Santiago Hills",
              "Springbrook",
              "Stone Creek",
              "Stonegate",
              "Turtle Rock",
              "University Park",
              "Vista Verde"
            ],
            note: "Among the 24 elementary schools in IUSD"  
          },
          {
            name: "K-8 Schools",
            list: [
              "Beacon Park",
              "Cadence Park",
              "Plaza Vista",
              "Solis Park",
              "Vista Verde"
            ],
            note: "5 K-8 campuses"  
          },
          {
            name: "Middle Schools",
            list: [
              "Jeffrey Trail",
              "Lakeside",
              "Rancho San Joaquin",
              "Sierra Vista",
              "South Lake",
              "Venado"
            ],
            note: "6 middle schools" 
          }
        ]
      },
      {
        category: "Higher Education — Irvine Region",
        items: [
          {
            name: "University of California, Irvine (UCI)",
            address: "Irvine, CA 92697",
            website: "https://uci.edu",
            note: "Major public research university"  
          },
          {
            name: "Irvine Valley College",
            address: "Irvine, CA",
            website: "https://www.ivc.edu",
            note: "Well-regarded community college" 
          },
          {
            name: "Concordia University Irvine (Private)",
            address: "1530 Concordia West, Irvine, CA 92612",
            phone: "(949) 854-8002",
            website: "https://www.cui.edu",
            note: "Private Lutheran university (enrollment ~4,000)"  
          },
          {
            name: "Westcliff University (Private for-profit)",
            address: "16715 Von Karman Avenue / 17877 Von Karman Avenue, Irvine, CA",
            website: "https://www.westcliff.edu",
            note: "Offers online degrees, acquired Western State College of Law"  
          },
          {
            name: "Stanbridge University (Career & Health)",
            note: "Private for-profit offering allied health programs; flagship campus in Irvine"  },
          {
            name: "Tarbut V’ Torah Community Day School (Private K-12)",
            note: "Jewish non-denominational TK-12 day school, Blue Ribbon recipient"  
          }
        ]
      }
    ],
  },
  "ca/orange-county": {
    city: "Orange County",
    state: "CA",
    sections: [
      {
        category: "County Administration",
        items: [
          {
            name: "County of Orange – Administration North",
            address: "400 W. Civic Center Drive, Santa Ana, CA 92701",
            phone: "855-886-5400 (Directory Assistance)",
            website: "https://www.ocgov.com/about-county/contact-county",
          }
        ]
      },
      {
        category: "Sheriff-Coroner",
        items: [
          {
            name: "Orange County Sheriff-Coroner",
            address: "Headquarters, Santa Ana, CA",
            sheriff: "Don Barnes",
            website: "https://en.wikipedia.org/wiki/Orange_County_Sheriff%27s_Department",
          }
        ]
      },
      {
        category: "Treasurer-Tax Collector",
        items: [
          {
            name: "Treasurer-Tax Collector (County of Orange)",
            address: "601 North Ross St., Second Floor, Santa Ana, CA 92701",
            phone: "(714) 834-3411",
            website: "https://www.octreasurer.gov/contact-1",
          }
        ]
      }
    ]
  },
"ca/san-clemente": {
    city: "San Clemente",
    state: "CA",
    sections: [
      {
  category: "City Council",
  items: [
    {
      name: "San Clemente City Council",
      address: "910 Calle Negocio, San Clemente, CA 92673",
      phone: "(949) 361-8322",
      website: "https://www.san-clemente.org/government/city-council",
      hours: "Mon–Thu 7:30 am–5:30 pm; alternate Fri 8 am–5 pm",
      email: "CityHall@san-clemente.org",
      people: [
        { title: "Mayor", name: "Steve Knoblock" },
        { title: "Mayor Pro Tem", name: "Mark Enmeier" },
        { title: "Councilmember", name: "Victor Cabral" },
        { title: "Councilmember", name: "Rick Loeffler" },
        { title: "Councilmember", name: "Zhen Wu" }
      ],
      note: "San Clemente City Council members are elected at-large."  
    }
  ]
},
      {
        category: "City Council / Clerk",
        items: [
          {
            name: "City Clerk’s Office / City Council Matters",
            address: "910 Calle Negocio, San Clemente, CA 92673",
            phone: "(949) 361-8200 (Clerk); (949) 361-8322 (Council)",
            email: "CityClerk@san-clemente.org",
          }
        ]
      },
      {
        category: "Marine Safety / Utilities",
        items: [
          {
            name: "Marine Safety Headquarters",
            address: "620 Avenida Del Mar, San Clemente, CA 92672",
            phone: "(949) 361-8219",
          },
          {
            name: "Utility Billing",
            address: "910 Calle Negocio, San Clemente, CA 92673",
            phone: "(949) 361-8315",
          },
          {
            name: "Water and Sewer Services",
            address: "380 Avenida Pico, San Clemente, CA 92672",
            phone: "(949) 366-1553",
          },
          {
            name: "Maintenance Yard (Public Works)",
            address: "390 Avenida Pico, San Clemente, CA 92672",
            phone: "(949) 361-8317",
          },
          {
            name: "San Clemente Aquatics Center",
            address: "987 Avenida Vista Hermosa, San Clemente, CA 92673",
            phone: "(949) 429-8797",
          }
        ]
      },{
      category: "Public Education (Capistrano Unified School District)",
      items: [
        {
          name: "Capistrano Unified School District (District Office)",
          address: "33122 Valle Road, San Juan Capistrano, CA 92675",
          phone: "(949) 234-9200",
          website: "https://www.capousd.org",
        },
        {
          name: "San Clemente High School (9–12)",
          address: "700 Avenida Pico, San Clemente, CA 92673",
          phone: "(949) 492-4165",
          principal: "Brad Baker",
          programs: ["International Baccalaureate (IB)", "Advanced Placement (AP)"],
          website: "https://sctritons.capousd.org",
        },
        {
          name: "Bernice Ayer Middle School (6–8)",
          address: "111 Avenida Vista Montana, San Clemente, CA 92672",
          phone: "(949) 366-9607",
          website: "https://bayermiddle.capousd.org",
        },
        {
          name: "Shorecliffs Middle School (6–8)",
          address: "240 Via Socorro, San Clemente, CA 92672",
          phone: "(949) 492-3538",
          website: "https://shorecliffs.capousd.org",
        },
        {
          name: "Vista del Mar Middle School (6–8)",
          address: "1130 Avenida Talega, San Clemente, CA 92673",
          phone: "(949) 234-5950",
          website: "https://vistadelmarmiddle.capousd.org",
        },
        {
          name: "Clarence Lobo Elementary School (K–5)",
          address: "200 Avenida Vista Montana, San Clemente, CA 92672",
          phone: "(949) 366-6740",
          website: "https://lobo.capousd.org",
        },
        {
          name: "Concordia Elementary School (K–5)",
          address: "3120 Avenida Del Presidente, San Clemente, CA 92672",
          phone: "(949) 492-3067",
          website: "https://concordia.capousd.org",
        },
        {
          name: "Las Palmas Elementary School (K–5, Dual Immersion)",
          address: "1101 Calle Puente, San Clemente, CA 92672",
          phone: "(949) 492-2675",
          website: "https://laspalmas.capousd.org",
        },
        {
          name: "Marblehead Elementary School (K–5)",
          address: "241 Avenida Vista Montana, San Clemente, CA 92672",
          phone: "(949) 234-5320",
          website: "https://marblehead.capousd.org",
        },
        {
          name: "Truman Benedict Elementary School (K–5)",
          address: "1251 Sarmentoso, San Clemente, CA 92673",
          phone: "(949) 366-0500",
          website: "https://benedict.capousd.org",
        },
        {
          name: "Vista del Mar Elementary School (K–5)",
          address: "1130 Avenida Talega, San Clemente, CA 92673",
          phone: "(949) 234-5940",
          website: "https://vistadelmarelementary.capousd.org",
        }
      ]
    },
    {
      category: "Private / Other Education",
      items: [
        {
          name: "Our Lady of Fatima Catholic School (PreK–8)",
          address: "105 North La Esperanza, San Clemente, CA 92672",
          phone: "(949) 492-7320",
          website: "https://www.olfs.org",
        },
        {
          name: "St. Michael’s Academy (Private Christian, K–12)",
          address: "300 Calle Iglesia, San Clemente, CA 92672",
          phone: "(949) 366-8464",
          website: "https://stmichael.academy",
        },
        {
          name: "San Clemente Christian School (PreK–8)",
          address: "1311 Calle Avanzado, San Clemente, CA 92673",
          phone: "(949) 496-3513",
          website: "https://sccs.org",
        }
      ]
    },{
        category: "Public Library (OC Public Libraries)",
        items: [
          {
            name: "San Clemente Library (OC Public Libraries)",
            address: "242 Avenida Del Mar, San Clemente, CA 92672",
            phone: "(949) 492-3493",
            email: "ocpl.sanclemente@occr.ocgov.com",
            hours: "Sun 9 am–5 pm; Mon–Thu 10 am–7 pm; Fri–Sat 9 am–5 pm",
            services: [
              "Public computers",
              "Free Wi-Fi",
              "Wireless printing",
              "Hotspot lending",
              "Laptop kiosk",
              "Book clubs",
              "Bilingual storytime",
              "Library of Things (toys, kitchen items, tech)",
              "Braille collection",
              "Erle Stanley Gardner microfilm collection"
            ],
            website: "https://www.ocpl.org/libraries/san-clemente",
          },
          {
            name: "San Clemente Friends of the Library",
            bookstoreHours: "Mon–Fri 11 am–2 pm; Sat 10 am–4 pm; Select Sundays",
            note: "Volunteer group that runs the bookstore and supports library programs",
            website: "https://sanclementefotl.org",
          }
        ]
      },
      {
        category: "Police Services (OC Sheriff)",
        items: [
          {
            name: "San Clemente Police Services (Orange County Sheriff’s Department)",
            address: "910 Calle Negocio, San Clemente, CA 92673",
            nonEmergencyDispatch: "(714) 647-7000 or (949) 770-6011",
            localPhone: "(949) 361-8225",
            chief: "Captain Justin Chevalier",
            staffing: {
              sergeants: 5,
              patrolDeputies: 37,
              trafficDeputies: 2,
              schoolResourceDeputy: 1,
              investigators: 4,
              communityServicesOfficers: 4,
              officeSpecialists: 2
            },
            specialUnits: [
              "TRIP team",
              "Directed Enforcement deputy",
              "RSVP volunteers"
            ],
            note: "Law enforcement contracted through OCSD.",
          }
        ]
      }
    ]
  },
  "ca/california": {
    city: "California",
    state: "CA",
    sections: [
      {
        category: "Governor",
        items: [
          {
            name: "Governor Gavin Newsom",
            office: "State Capitol, Suite 9000",
            address: "1021 O Street, Sacramento, CA 95814",
            phone: "(916) 445-2841",
            fax: "(916) 558-3160",
            email: "governor@governor.ca.gov",
            website: "https://www.gov.ca.gov",
            map: "https://maps.google.com/?q=1021+O+Street,+Suite+9000,+Sacramento,+CA+95814",
          },
        ],
      },
      {
        category: "Lieutenant Governor",
        items: [
          {
            name: "Lieutenant Governor Eleni Kounalakis",
            office: "State Capitol, Suite 8730",
            address: "1021 O Street, Sacramento, CA 95814",
            phone: "(916) 445-8994",
            website: "https://ltg.ca.gov",
          },
        ],
      },
      {
        category: "Attorney General",
        items: [
          {
            name: "Attorney General Rob Bonta",
            office: "California Department of Justice",
            address: "1300 I Street, Sacramento, CA 95814",
            phone: "(916) 445-9555",
            website: "https://oag.ca.gov",
          },
        ],
      },
      {
        category: "Controller",
        items: [
          {
            name: "State Controller Malia Cohen",
            office: "300 Capitol Mall, Suite 1850",
            address: "300 Capitol Mall, Sacramento, CA 95814",
            phone: "(916) 445-2636",
            website: "https://www.sco.ca.gov",
          },
        ],
      },
      {
        category: "Secretary of State",
        items: [
          {
            name: "Secretary of State Shirley Weber",
            office: "1500 11th Street",
            address: "1500 11th Street, Sacramento, CA 95814",
            phone: "(916) 653-7244",
            website: "https://www.sos.ca.gov",
          },
        ],
      },
      {
        category: "Treasurer",
        items: [
          {
            name: "State Treasurer Fiona Ma",
            office: "915 Capitol Mall, Suite 110",
            address: "915 Capitol Mall, Sacramento, CA 95814",
            phone: "(916) 653-2995",
            website: "https://www.treasurer.ca.gov",
          },
        ],
      },
      {
        category: "Insurance Commissioner",
        items: [
          {
            name: "Insurance Commissioner Ricardo Lara",
            office: "300 Capitol Mall, 17th Floor",
            address: "300 Capitol Mall, Sacramento, CA 95814",
            phone: "(916) 492-3500",
            website: "https://www.insurance.ca.gov",
          },
        ],
      },
      {
        category: "Superintendent of Public Instruction",
        items: [
          {
            name: "State Superintendent Tony Thurmond",
            office: "1430 N Street, Suite 5602",
            address: "1430 N Street, Sacramento, CA 95814",
            phone: "(916) 319-0800",
            website: "https://www.cde.ca.gov",
          },
        ],
      },
      {
        category: "Board of Equalization",
        items: [
          {
            name: "State Board of Equalization – District 2",
            office: "621 Capitol Mall, Room 2100",
            address: "621 Capitol Mall, Sacramento, CA 95814",
            phone: "(916) 445-4081",
            website: "https://www.boe.ca.gov",
          },
        ],
      },
      {
        category: "Legislative Counsel",
        items: [
          {
            name: "Office of Legislative Counsel (California)",
            office: "State Capitol, Suite 3210",
            address: "1021 O Street, Sacramento, CA 95814",
            chief: "Legislative Counsel: Cara L. Jenkins",
            website: "https://legislativecounsel.ca.gov",
          },
        ],
      },
    ],
  },
  "ca/newport-beach": {
    city: "Newport Beach",
    state: "CA",
    sections: [
      {
        category: "City Administration",
        items: [
          {
            name: "City of Newport Beach – City Hall",
            address: "100 Civic Center Drive, Newport Beach, CA 92660",
            phone: "(949) 644-3309",
            website: "https://www.newportbeachca.gov",
          },
          {
            name: "City Manager: Grace Leung",
            contact: "Phone: (949) 644-3001, Email: gleung@newportbeachca.gov",
          },
        ],
      },
      {
      category: "City Council",
      items: [
        {
          name: "Newport Beach City Council",
          address: "100 Civic Center Drive, Newport Beach, CA 92660",
          phone: "(949) 644-3004",
          email: "citycouncil@newportbeachca.gov",
          website: "https://www.newportbeachca.gov/government/city-council",
          people: [
            { title: "Mayor", name: "Joe Stapleton", district: "District 1", email: "jstapleton@newportbeachca.gov" },
            { title: "Mayor Pro Tem", name: "Lauren Kleiman", district: "District 6", email: "lkleiman@newportbeachca.gov" },
            { title: "Council member", name: "Michelle Barto", district: "District 2", email: "mbarto@newportbeachca.gov" },
            { title: "Council member", name: "Erik Weigand", district: "District 3", email: "eweigand@newportbeachca.gov" },
            { title: "Council member", name: "Robyn Grant", district: "District 4", email: "rgrant@newportbeachca.gov" },
            { title: "Council member", name: "Noah Blom", district: "District 5", email: "nblom@newportbeachca.gov" },
            { title: "Council member", name: "Sara J. Weber", district: "District 7", email: "sweber@newportbeachca.gov" }
          ]
        }
      ]
    },
      {
        category: "City Clerk",
        items: [
          {
            name: "Office of the City Clerk",
            address: "Bay E, 2nd Floor, 100 Civic Center Drive, Newport Beach, CA 92660",
            phone: "(949) 644-3005",
            fax: "(949) 644-3039",
            email: "cityclerk@newportbeachca.gov",
            personnel: [
              { role: "Interim City Clerk", name: "Molly Perry", email: "mperry@newportbeachca.gov" },
              { role: "Assistant City Clerk", name: "Jennifer Farris", email: "jfarris@newportbeachca.gov" },
              { role: "Records Specialist", name: "Cassandra Hawks", email: "chawks@newportbeachca.gov" },
              { role: "Admin Assistant", name: "Jennifer Mulvey", email: "jmulvey@newportbeachca.gov" },
            ],
          },
        ],
      },
      {
        category: "Public Works",
        items: [
          {
            name: "Public Works Department – General Info",
            address: "City Hall, 2nd Floor, Bay D, 100 Civic Center Drive, Newport Beach, CA 92660",
            phone: "(949) 644-3311",
            fax: "(949) 644-3318",
            email: "pwinfo@newportbeachca.gov",
          },
          {
            name: "Public Works Director: Dave Webb",
            address: "Public Works Department, 100 Civic Center Drive, Bay 2D, Newport Beach, CA 92660",
            phone: "(949) 644-3330",
            email: "dawebb@newportbeachca.gov",
          },
        ],
      },
      {
        category: "Police Services",
        items: [
          {
            name: "Police – Dispatch / After-Hours (Public Works)",
            phone: "(949) 644-3717 (non-emergency dispatch)",
            note: "For after-hours Public Works emergencies",
          },
          {
            name: "Animal Control",
            phone: "(949) 644-3717",
            note: "Public Works service directory",
          },
        ],
      },
      {
        category: "Planning & Community Development",
        items: [
          {
            name: "Community Development Department (Main Line)",
            phone: "(949) 644-3200",
            personnel: [
              { role: "Assistant City Manager / CD Director", name: "Seimone Jurjis", email: "sjurjis@newportbeachca.gov" },
            ],
          },
          {
            name: "Permit Counter",
            phone: "(949) 718-1888",
          },
          {
            name: "Planning & Zoning Information",
            phone: "(949) 644-3204",
          },
          {
            name: "Code Enforcement",
            phone: "(949) 644-3215",
          },
        ],
      },
      {
        category: "Library Services",
        items: [
          {
            name: "Central Library (OC Public Libraries)",
            address: "1000 Avocado Avenue, Newport Beach, CA",
            phone: "Customer Service: (949) 717-3800",
            hours: "Mon–Thu 9 a m–9 p m, Fri–Sat 9 a m–6 p m, Sun Noon–5 p m",
          },
        ],
      },
      {
        category: "Chamber of Commerce",
        items: [
          {
            name: "Newport Beach Chamber of Commerce",
            address: "4343 Von Karman Ave., Ste. 150-W, Newport Beach, CA 92660",
            phone: "(949) 729-4400",
            website: "https://www.newportbeach.com",
          },
        ],
      },
      {
        category: "Public Schools (Newport-Mesa USD)",
        items: [
          {
            name: "Eastbluff Elementary School (TK-6)",
            address: "2627 Vista del Oro, Newport Beach, CA 92660",
            phone: "(949) 515-5920",
          },
          {
            name: "Mariners Elementary School (TK-6)",
            address: "2100 Mariners Drive, Newport Beach, CA 92660",
            phone: "(949) 515-6960",
          },
          {
            name: "Newport Elementary School (TK-6)",
            address: "1327 W Balboa Blvd, Newport Beach, CA 92661",
            phone: "(949) 515-6965",
          },
          {
            name: "Newport Coast Elementary School (TK-6)",
            address: "6655 Ridge Park Rd, Newport Coast, CA 92657",
            phone: "(949) 515-6975",
          },
          {
            name: "Newport Heights Elementary School (TK-6)",
            address: "300 E 15th St, Newport Beach, CA 92663",
            phone: "(949) 515-6970",
          },
          {
            name: "Corona del Mar Middle & High School (7-12)",
            address: "2101 Eastbluff Drive, Newport Beach, CA 92660",
            phone: "(949) 515-6000",
          },
          {
            name: "Newport Harbor High School (9-12)",
            address: "600 Irvine Ave, Newport Beach, CA 92663",
            phone: "(949) 515-6300",
          },
          {
            name: "Sage Hill School (Private, 7-12)",
            address: "20402 Newport Coast Drive, Newport Coast, CA 92657",
            phone: "949-219-0100",
          },
        ],
      },
    ],
  },
  "ca/mission-viejo": {
    city: "Mission Viejo",
    state: "CA",
    sections: [
      {
  category: "City Council",
  items: [
    {
      name: "Mission Viejo City Council",
      address: "200 Civic Center, Mission Viejo, CA 92691",
      phone: "(949) 470-3050",
      email: "citycouncil@cityofmissionviejo.org",
      website: "https://www.cityofmissionviejo.org/government/city-council",
      people: [
        { title: "Mayor", name: "Bob Ruesch", email: "rruesch@cityofmissionviejo.org" },
        { title: "Mayor Pro Tem", name: "Wendy Bucknum", email: "wbucknum@cityofmissionviejo.org" },
        { title: "Council member", name: "Brian Goodell" },
        { title: "Council member", name: "Patricia “Trish” Kelley" },
        { title: "Council member", name: "Cynthia Vasquez", district: "District 3" }
      ],
      note: "Mayor and Mayor Pro Tem selected annually by the Council."
    }
  ]
},

      {
        category: "Police Services (OC Sheriff)",
        items: [
          {
            name: "Mission Viejo Police Services (Orange County Sheriff’s Department)",
            address: "200 Civic Center, Mission Viejo, CA 92691",
            nonEmergencyDispatch: "(949) 770-6011",
            note: "Mission Viejo contracts with OCSD for law enforcement",
            staffing: {
              sergeants: 5,
              deputies: 35,
              motorDeputies: 4,
              schoolResourceOfficers: 5
            },
          }
        ]
      },

      {
        category: "Public Library (Mission Viejo)",
        items: [
          {
            name: "Mission Viejo Public Library",
            address: "100 Civic Center, Mission Viejo, CA 92691",
            phone: "(949) 830-7100",
            hours: "Mon–Tue 10 am–9 pm; Wed–Thu 10 am–9 pm; Fri–Sat 10 am–5 pm; Sun 12 pm–5 pm",
            note: "27,500 sq ft facility opened 1997; expanded 2000.",
          }
        ]
      },

      {
        category: "Public Education (Mission Viejo)",
        items: [
          {
            name: "Capistrano Unified School District (District Office)",
            address: "33122 Valle Road, San Juan Capistrano, CA",
            phone: "(949) 234-9200",
            website: "https://www.capousd.org",
          },
          {
            name: "Saddleback Valley Unified School District (District Office)",
            address: "25631 Peter A. Hartman Way, Mission Viejo, CA",
            phone: "(949) 580-3200",
            website: "https://www.svusd.org",
          },
          {
            name: "Mission Viejo High School (SVUSD, 9–12)",
            address: "25025 Chrisanta Drive, Mission Viejo, CA 92691",
            phone: "(949) 837-7722",
          },
          {
            name: "Trabuco Hills High School (SVUSD, 9–12)",
            address: "27501 Mustang Run, Mission Viejo, CA 92691",
          },
          {
            name: "Capistrano Valley High School (CUSD, 9–12)",
            address: "26301 Via Escolar, Mission Viejo, CA 92691",
          },
          {
            name: "Bathgate Elementary School (CUSD, K-5)",
            address: "27642 Napoli Way, Mission Viejo, CA 92692",
          },
          {
            name: "Carl Hankey Academy (CUSD, K-8)",
            address: "27252 Nubles, Mission Viejo, CA 92692",
          },
          {
            name: "Del Cerro Elementary School (SVUSD, K-6)",
            address: "24382 Regina St, Mission Viejo, CA 92691",
          },
          {
            name: "Del Lago Elementary School (SVUSD, K-6)",
            address: "27181 Entidad, Mission Viejo, CA 92691",
          },
          {
            name: "La Paz Intermediate School (SVUSD, 7–8)",
            address: "25151 Pradera Dr, Mission Viejo, CA 92691",
          },
          {
            name: "Los Alisos Intermediate School (SVUSD, 7–8)",
            address: "25171 Moor Ave, Mission Viejo, CA 92691",
          }
        ]
      },

      {
        category: "Private / Other Education",
        items: [
          {
            name: "Oxford Preparatory Academy - South Orange County (K-8)",
            address: "23000 Via Santa Maria, Mission Viejo, CA 92691",
          },
          {
            name: "Mission Viejo Christian School (K-8)",
          }
        ]
      }
       ],
  },
  "ca/huntington-beach": {
  city: "Huntington Beach",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Huntington Beach",
          address: "2000 Main St, Huntington Beach, CA 92648",
          phone: "(714) 536-5511",
          website: "https://www.huntingtonbeachca.gov/",
          map: "https://maps.google.com/?q=2000+Main+St,+Huntington+Beach,+CA+92648",
          people: [
            { title: "City Manager", name: "—" },
            { title: "City Clerk", name: "—" },
            { title: "Community Development Director", name: "—" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Huntington Beach Police Department",
          address: "2000 Main St, Huntington Beach, CA 92648",
          phone: "(714) 960-8825 (Non-Emergency)",
          website: "https://www.huntingtonbeachca.gov/government/departments/police/",
          map: "https://maps.google.com/?q=2000+Main+St,+Huntington+Beach,+CA+92648",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Huntington Beach Central Library",
          address: "7111 Talbert Ave, Huntington Beach, CA 92648",
          phone: "(714) 842-4481",
          email: "",
          website: "https://www.huntingtonbeachca.gov/government/departments/library/",
          map: "https://maps.google.com/?q=7111+Talbert+Ave,+Huntington+Beach,+CA+92648"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Huntington Beach High School",
          address: "1905 Main St, Huntington Beach, CA 92648",
          phone: "(714) 536-2514",
          website: "https://www.hbuhsd.edu/",
          map: "https://maps.google.com/?q=1905+Main+St,+Huntington+Beach,+CA+92648"
        },
        {
          name: "Ocean View High School",
          address: "17071 Gothard St, Huntington Beach, CA 92647",
          phone: "(714) 893-1381",
          website: "https://ovhs.ovsd.org/",
          map: "https://maps.google.com/?q=17071+Gothard+St,+Huntington+Beach,+CA+92647"
        },
        {
          name: "Edison High School",
          address: "21400 Magnolia St, Huntington Beach, CA 92646",
          phone: "(714) 962-1356",
          website: "https://www.edisonchargers.com/",
          map: "https://maps.google.com/?q=21400+Magnolia+St,+Huntington+Beach,+CA+92646"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. Bonaventure Catholic School",
          address: "16377 Bradbury Ln, Huntington Beach, CA 92647",
          phone: "(714) 846-2472",
          website: "https://www.stbonaventureschool.org/",
          map: "https://maps.google.com/?q=16377+Bradbury+Ln,+Huntington+Beach,+CA+92647"
        },
        {
          name: "The Pegasus School",
          address: "19692 Lexington Ln, Huntington Beach, CA 92646",
          phone: "(714) 964-5568",
          website: "https://www.thepegasusschool.org/",
          map: "https://maps.google.com/?q=19692+Lexington+Ln,+Huntington+Beach,+CA+92646"
        }
      ]
    }
  ]
},
"ca/laguna-hills": {
  city: "Laguna Hills",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Laguna Hills",
          address: "24035 El Toro Rd, Laguna Hills, CA 92653",
          phone: "(949) 707-2600",
          website: "https://www.lagunahillsca.gov/",
          map: "https://maps.google.com/?q=24035+El+Toro+Rd,+Laguna+Hills,+CA+92653",
          people: [
            { title: "City Manager", name: "—" },
            { title: "City Clerk", name: "—" },
            { title: "Community Development Director", name: "—" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Laguna Hills Police Services (OC Sheriff)",
          address: "24035 El Toro Rd, Laguna Hills, CA 92653",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/laguna-hills",
          map: "https://maps.google.com/?q=24035+El+Toro+Rd,+Laguna+Hills,+CA+92653",
          notes: "Law enforcement provided via contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Laguna Hills Technology Library (OC Public Libraries)",
          address: "25555 Alicia Pkwy, Laguna Hills, CA 92653",
          phone: "(949) 707-2699",
          email: "",
          website: "https://ocpl.org/libraries/laguna-hills",
          map: "https://maps.google.com/?q=25555+Alicia+Pkwy,+Laguna+Hills,+CA+92653"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Laguna Hills High School",
          address: "25401 Paseo de Valencia, Laguna Hills, CA 92653",
          phone: "(949) 770-5447",
          website: "https://www.lhhs.org/",
          map: "https://maps.google.com/?q=25401+Paseo+de+Valencia,+Laguna+Hills,+CA+92653"
        },
        {
          name: "Los Alisos Intermediate School",
          address: "25171 Moor Ave, Laguna Hills, CA 92653",
          phone: "(949) 830-0970",
          website: "https://losalisos.svusd.org/",
          map: "https://maps.google.com/?q=25171+Moor+Ave,+Laguna+Hills,+CA+92653"
        },
        {
          name: "Lomarena Elementary School",
          address: "25100 Earhart Rd, Laguna Hills, CA 92653",
          phone: "(949) 830-8600",
          website: "https://lomarena.svusd.org/",
          map: "https://maps.google.com/?q=25100+Earhart+Rd,+Laguna+Hills,+CA+92653"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Laguna Hills Montessori",
          address: "23251 La Plata Dr, Laguna Hills, CA 92653",
          phone: "(949) 581-2800",
          website: "https://www.lagunahillsmontessori.com/",
          map: "https://maps.google.com/?q=23251+La+Plata+Dr,+Laguna+Hills,+CA+92653"
        }
      ]
    }
  ]
},
"ca/aliso-viejo": {
  city: "Aliso Viejo",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Aliso Viejo",
          address: "12 Journey, Suite 100, Aliso Viejo, CA 92656",
          phone: "(949) 425-2500",
          website: "https://avcity.org/",
          map: "https://maps.google.com/?q=12+Journey,+Suite+100,+Aliso+Viejo,+CA+92656",
          people: [
            { title: "City Manager", name: "David Doyle", phone: "(949) 425-2510", email: "ddoyle@avcity.org" },
            { title: "City Clerk", name: "Amanda Antenore", phone: "(949) 425-2505", email: "aantenore@avcity.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Aliso Viejo Police Services (OC Sheriff)",
          address: "11 Journey, Aliso Viejo, CA 92656",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/aliso-viejo",
          map: "https://maps.google.com/?q=11+Journey,+Aliso+Viejo,+CA+92656",
          notes: "Law enforcement via contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Aliso Viejo Library (OC Public Libraries)",
          address: "1 Journey, Aliso Viejo, CA 92656",
          phone: "(949) 360-1730",
          website: "https://ocpl.org/libraries/aliso-viejo",
          map: "https://maps.google.com/?q=1+Journey,+Aliso+Viejo,+CA+92656"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Aliso Niguel High School",
          address: "28000 Wolverine Way, Aliso Viejo, CA 92656",
          phone: "(949) 831-5590",
          website: "https://anhs-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=28000+Wolverine+Way,+Aliso+Viejo,+CA+92656"
        },
        {
          name: "Don Juan Avila Middle School",
          address: "26278 Wood Canyon Dr, Aliso Viejo, CA 92656",
          phone: "(949) 362-0348",
          website: "https://djam-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=26278+Wood+Canyon+Dr,+Aliso+Viejo,+CA+92656"
        },
        {
          name: "Wood Canyon Elementary School",
          address: "23431 Knollwood, Aliso Viejo, CA 92656",
          phone: "(949) 448-0012",
          website: "https://wcanyon-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=23431+Knollwood,+Aliso+Viejo,+CA+92656"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. Mary’s School (K–8, Episcopal)",
          address: "7 Pursuit, Aliso Viejo, CA 92656",
          phone: "(949) 448-9027",
          website: "https://www.smaa.org/",
          map: "https://maps.google.com/?q=7+Pursuit,+Aliso+Viejo,+CA+92656"
        },
        {
          name: "Aliso Viejo Christian School",
          address: "1 Orion, Aliso Viejo, CA 92656",
          phone: "(949) 389-0300",
          website: "https://www.alisoviejochristianschool.org/",
          map: "https://maps.google.com/?q=1+Orion,+Aliso+Viejo,+CA+92656"
        }
      ]
    }
  ]
},

"ca/anaheim": {
  city: "Anaheim",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Anaheim",
          address: "200 S Anaheim Blvd, Anaheim, CA 92805",
          phone: "(714) 765-4311",
          website: "https://www.anaheim.net/",
          map: "https://maps.google.com/?q=200+S+Anaheim+Blvd,+Anaheim,+CA+92805",
          people: [
            { title: "City Manager", name: "James Vanderpool", phone: "(714) 765-4300", email: "jvanderpool@anaheim.net" },
            { title: "City Clerk", name: "Theresa Bass", phone: "(714) 765-5166", email: "tbass@anaheim.net" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Anaheim Police Department",
          address: "425 S Harbor Blvd, Anaheim, CA 92805",
          phone: "(714) 765-1900 (Non-Emergency)",
          website: "https://www.anaheim.net/police",
          map: "https://maps.google.com/?q=425+S+Harbor+Blvd,+Anaheim,+CA+92805",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Anaheim Central Library",
          address: "500 W Broadway, Anaheim, CA 92805",
          phone: "(714) 765-1880",
          website: "https://www.anaheim.net/106/library-services",
          map: "https://maps.google.com/?q=500+W+Broadway,+Anaheim,+CA+92805"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Anaheim High School",
          address: "811 W Lincoln Ave, Anaheim, CA 92805",
          phone: "(714) 999-3717",
          website: "https://anaheim.auhsd.us/",
          map: "https://maps.google.com/?q=811+W+Lincoln+Ave,+Anaheim,+CA+92805"
        },
        {
          name: "Katella High School",
          address: "2200 E Wagner Ave, Anaheim, CA 92806",
          phone: "(714) 999-3621",
          website: "https://katella.auhsd.us/",
          map: "https://maps.google.com/?q=2200+E+Wagner+Ave,+Anaheim,+CA+92806"
        },
        {
          name: "Loara High School",
          address: "1765 W Cerritos Ave, Anaheim, CA 92804",
          phone: "(714) 999-3677",
          website: "https://loara.auhsd.us/",
          map: "https://maps.google.com/?q=1765+W+Cerritos+Ave,+Anaheim,+CA+92804"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Cornelia Connelly School (Catholic, all-girls)",
          address: "2323 W Broadway, Anaheim, CA 92804",
          phone: "(714) 776-1717",
          website: "https://connellyschoolanaheim.org/",
          map: "https://maps.google.com/?q=2323+W+Broadway,+Anaheim,+CA+92804"
        },
        {
          name: "Fairmont Private School – Anaheim Hills Campus",
          address: "5310 E La Palma Ave, Anaheim, CA 92807",
          phone: "(714) 693-3812",
          website: "https://www.fairmontschools.com/",
          map: "https://maps.google.com/?q=5310+E+La+Palma+Ave,+Anaheim,+CA+92807"
        }
      ]
    }
  ]
},
"ca/brea": {
  city: "Brea",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Brea",
          address: "1 Civic Center Circle, Brea, CA 92821",
          phone: "(714) 990-7600",
          website: "https://www.ci.brea.ca.us/",
          map: "https://maps.google.com/?q=1+Civic+Center+Circle,+Brea,+CA+92821",
          people: [
            { title: "City Manager", name: "Tamara Letourneau", phone: "(714) 990-7700", email: "tamaral@cityofbrea.net" },
            { title: "City Clerk", name: "Cindy Russell", phone: "(714) 990-7756", email: "cindyr@cityofbrea.net" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Brea Police Department",
          address: "1 Civic Center Circle, Brea, CA 92821",
          phone: "(714) 990-7625 (Non-Emergency)",
          website: "https://www.ci.brea.ca.us/183/Police",
          map: "https://maps.google.com/?q=1+Civic+Center+Circle,+Brea,+CA+92821",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Brea Library (OC Public Libraries)",
          address: "1 Civic Center Circle, Brea, CA 92821",
          phone: "(714) 671-1722",
          website: "https://ocpl.org/libraries/brea",
          map: "https://maps.google.com/?q=1+Civic+Center+Circle,+Brea,+CA+92821"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Brea Olinda High School",
          address: "789 Wildcat Way, Brea, CA 92821",
          phone: "(714) 990-7850",
          website: "https://bohs-bousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=789+Wildcat+Way,+Brea,+CA+92821"
        },
        {
          name: "Brea Junior High School",
          address: "400 N Brea Blvd, Brea, CA 92821",
          phone: "(714) 990-7500",
          website: "https://bjhs-bousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=400+N+Brea+Blvd,+Brea,+CA+92821"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Brea Olinda Friends Christian School",
          address: "200 S Associated Rd, Brea, CA 92821",
          phone: "(714) 529-6332",
          website: "https://www.friendschristian.org/",
          map: "https://maps.google.com/?q=200+S+Associated+Rd,+Brea,+CA+92821"
        }
      ]
    }
  ]
},

"ca/buena-park": {
  city: "Buena Park",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Buena Park",
          address: "6650 Beach Blvd, Buena Park, CA 90621",
          phone: "(714) 562-3550",
          website: "https://www.buenapark.com/",
          map: "https://maps.google.com/?q=6650+Beach+Blvd,+Buena+Park,+CA+90621",
          people: [
            { title: "City Manager", name: "Aaron France", phone: "(714) 562-3550", email: "afrance@buenapark.com" },
            { title: "City Clerk", name: "Alicia D. Ortiz", phone: "(714) 562-3750", email: "aortiz@buenapark.com" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Buena Park Police Department",
          address: "6640 Beach Blvd, Buena Park, CA 90621",
          phone: "(714) 562-3901 (Non-Emergency)",
          website: "https://www.bppd.com/",
          map: "https://maps.google.com/?q=6640+Beach+Blvd,+Buena+Park,+CA+90621",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Buena Park Library District",
          address: "7150 La Palma Ave, Buena Park, CA 90620",
          phone: "(714) 826-4100",
          website: "https://buenaparklibrary.org/",
          map: "https://maps.google.com/?q=7150+La+Palma+Ave,+Buena+Park,+CA+90620"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Buena Park High School",
          address: "8833 Academy Dr, Buena Park, CA 90621",
          phone: "(714) 992-8600",
          website: "https://bphs.fullertonsd.org/",
          map: "https://maps.google.com/?q=8833+Academy+Dr,+Buena+Park,+CA+90621"
        },
        {
          name: "Buena Park Junior High School",
          address: "6931 Orangethorpe Ave, Buena Park, CA 90620",
          phone: "(714) 447-7755",
          website: "https://bpjh.fullertonsd.org/",
          map: "https://maps.google.com/?q=6931+Orangethorpe+Ave,+Buena+Park,+CA+90620"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. Pius V Catholic School",
          address: "7681 Orangethorpe Ave, Buena Park, CA 90621",
          phone: "(714) 522-5313",
          website: "https://stpius5school.net/",
          map: "https://maps.google.com/?q=7681+Orangethorpe+Ave,+Buena+Park,+CA+90621"
        },
        {
          name: "Fairmont Private School – Buena Park Campus",
          address: "531 N Dale Ave, Buena Park, CA 90631",
          phone: "(714) 521-4155",
          website: "https://www.fairmontschools.com/",
          map: "https://maps.google.com/?q=531+N+Dale+Ave,+Buena+Park,+CA+90631"
        }
      ]
    }
  ]
},
"ca/costa-mesa": {
  city: "Costa Mesa",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Costa Mesa",
          address: "77 Fair Drive, Costa Mesa, CA 92626",
          phone: "(714) 754-5000",
          website: "https://www.costamesaca.gov/",
          map: "https://maps.google.com/?q=77+Fair+Drive,+Costa+Mesa,+CA+92626",
          people: [
            { title: "City Manager", name: "Lori Ann Farrell Harrison", phone: "(714) 754-5107", email: "citymanager@costamesaca.gov" },
            { title: "City Clerk", name: "Brenda Green", phone: "(714) 754-5225", email: "cityclerk@costamesaca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Costa Mesa Police Department",
          address: "99 Fair Drive, Costa Mesa, CA 92626",
          phone: "(714) 754-5252 (Non-Emergency)",
          website: "https://www.costamesaca.gov/government/departments/police",
          map: "https://maps.google.com/?q=99+Fair+Drive,+Costa+Mesa,+CA+92626",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Donald Dungan Library (Costa Mesa)",
          address: "1855 Park Ave, Costa Mesa, CA 92627",
          phone: "(714) 566-3070",
          website: "https://ocpl.org/libraries/donald-dungan",
          map: "https://maps.google.com/?q=1855+Park+Ave,+Costa+Mesa,+CA+92627"
        },
        {
          name: "Mesa Verde Library (Costa Mesa)",
          address: "2969 Mesa Verde Dr E, Costa Mesa, CA 92626",
          phone: "(714) 546-5274",
          website: "https://ocpl.org/libraries/mesa-verde",
          map: "https://maps.google.com/?q=2969+Mesa+Verde+Dr+E,+Costa+Mesa,+CA+92626"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Costa Mesa High School",
          address: "2650 Fairview Rd, Costa Mesa, CA 92626",
          phone: "(714) 424-8700",
          website: "https://cmhs.nmusd.us/",
          map: "https://maps.google.com/?q=2650+Fairview+Rd,+Costa+Mesa,+CA+92626"
        },
        {
          name: "Estancia High School",
          address: "2323 Placentia Ave, Costa Mesa, CA 92627",
          phone: "(949) 515-6500",
          website: "https://estancia.nmusd.us/",
          map: "https://maps.google.com/?q=2323+Placentia+Ave,+Costa+Mesa,+CA+92627"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. John the Baptist Catholic School",
          address: "1021 Baker St, Costa Mesa, CA 92626",
          phone: "(714) 557-5060",
          website: "https://sjboc.org/school",
          map: "https://maps.google.com/?q=1021+Baker+St,+Costa+Mesa,+CA+92626"
        },
        {
          name: "Christ Lutheran School",
          address: "760 Victoria St, Costa Mesa, CA 92627",
          phone: "(949) 548-6866",
          website: "https://www.clscm.org/",
          map: "https://maps.google.com/?q=760+Victoria+St,+Costa+Mesa,+CA+92627"
        }
      ]
    }
  ]
},

"ca/cypress": {
  city: "Cypress",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Cypress",
          address: "5275 Orange Ave, Cypress, CA 90630",
          phone: "(714) 229-6700",
          website: "https://www.cypressca.org/",
          map: "https://maps.google.com/?q=5275+Orange+Ave,+Cypress,+CA+90630",
          people: [
            { title: "City Manager", name: "Peter Grant", phone: "(714) 229-6720", email: "pgrant@cypressca.org" },
            { title: "City Clerk", name: "Alisha Farnell", phone: "(714) 229-6682", email: "afarnell@cypressca.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Cypress Police Department",
          address: "5275 Orange Ave, Cypress, CA 90630",
          phone: "(714) 229-6600 (Non-Emergency)",
          website: "https://www.cypressca.org/government/departments/police",
          map: "https://maps.google.com/?q=5275+Orange+Ave,+Cypress,+CA+90630",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Cypress Library (OC Public Libraries)",
          address: "5331 Orange Ave, Cypress, CA 90630",
          phone: "(714) 826-0350",
          website: "https://ocpl.org/libraries/cypress",
          map: "https://maps.google.com/?q=5331+Orange+Ave,+Cypress,+CA+90630"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Cypress High School",
          address: "9801 Valley View St, Cypress, CA 90630",
          phone: "(714) 220-4144",
          website: "https://cypress.auhsd.us/",
          map: "https://maps.google.com/?q=9801+Valley+View+St,+Cypress,+CA+90630"
        },
        {
          name: "Lexington Junior High School",
          address: "4351 Orange Ave, Cypress, CA 90630",
          phone: "(714) 220-4201",
          website: "https://lexington.auhsd.us/",
          map: "https://maps.google.com/?q=4351+Orange+Ave,+Cypress,+CA+90630"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. Irenaeus Parish School",
          address: "9201 Grindlay St, Cypress, CA 90630",
          phone: "(714) 827-4500",
          website: "https://www.stischoolcypress.org/",
          map: "https://maps.google.com/?q=9201+Grindlay+St,+Cypress,+CA+90630"
        },
        {
          name: "Christ Lutheran School (Cypress)",
          address: "5220 Fairview Ave, Cypress, CA 90630",
          phone: "(714) 527-5181",
          website: "https://www.christcm.com/",
          map: "https://maps.google.com/?q=5220+Fairview+Ave,+Cypress,+CA+90630"
        }
      ]
    }
  ]
},
"ca/fountain-valley": {
  city: "Fountain Valley",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Fountain Valley",
          address: "10200 Slater Ave, Fountain Valley, CA 92708",
          phone: "(714) 593-4400",
          website: "https://www.fountainvalley.org/",
          map: "https://maps.google.com/?q=10200+Slater+Ave,+Fountain+Valley,+CA+92708",
          people: [
            { title: "City Manager", name: "Robert J. Houston", phone: "(714) 593-4410", email: "citymanager@fountainvalley.org" },
            { title: "City Clerk", name: "Rick Miller", phone: "(714) 593-4445", email: "cityclerk@fountainvalley.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Fountain Valley Police Department",
          address: "10200 Slater Ave, Fountain Valley, CA 92708",
          phone: "(714) 593-4485 (Non-Emergency)",
          website: "https://www.fountainvalley.org/160/Police",
          map: "https://maps.google.com/?q=10200+Slater+Ave,+Fountain+Valley,+CA+92708",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Fountain Valley Library (OC Public Libraries)",
          address: "17635 Los Alamos St, Fountain Valley, CA 92708",
          phone: "(714) 962-1324",
          website: "https://ocpl.org/libraries/fountain-valley",
          map: "https://maps.google.com/?q=17635+Los+Alamos+St,+Fountain+Valley,+CA+92708"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Fountain Valley High School",
          address: "17816 Bushard St, Fountain Valley, CA 92708",
          phone: "(714) 962-3301",
          website: "https://fvhs-hbuhsd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=17816+Bushard+St,+Fountain+Valley,+CA+92708"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Grace Lutheran School",
          address: "11231 Harbor Blvd, Fountain Valley, CA 92708",
          phone: "(714) 530-7391",
          website: "https://www.gracefv.org/",
          map: "https://maps.google.com/?q=11231+Harbor+Blvd,+Fountain+Valley,+CA+92708"
        }
      ]
    }
  ]
},

"ca/fullerton": {
  city: "Fullerton",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Fullerton",
          address: "303 W Commonwealth Ave, Fullerton, CA 92832",
          phone: "(714) 738-6300",
          website: "https://www.cityoffullerton.com/",
          map: "https://maps.google.com/?q=303+W+Commonwealth+Ave,+Fullerton,+CA+92832",
          people: [
            { title: "City Manager", name: "Eric Levitt", phone: "(714) 738-6310", email: "citymanager@cityoffullerton.com" },
            { title: "City Clerk", name: "Lucinda Williams", phone: "(714) 738-6350", email: "cityclerk@cityoffullerton.com" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Fullerton Police Department",
          address: "237 W Commonwealth Ave, Fullerton, CA 92832",
          phone: "(714) 738-6700 (Non-Emergency)",
          website: "https://www.fullertonpd.org/",
          map: "https://maps.google.com/?q=237+W+Commonwealth+Ave,+Fullerton,+CA+92832",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Fullerton Public Library",
          address: "353 W Commonwealth Ave, Fullerton, CA 92832",
          phone: "(714) 738-6333",
          website: "https://www.fullertonlibrary.org/",
          map: "https://maps.google.com/?q=353+W+Commonwealth+Ave,+Fullerton,+CA+92832"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Fullerton Union High School",
          address: "201 E Chapman Ave, Fullerton, CA 92832",
          phone: "(714) 626-3800",
          website: "https://fuha.fullertonunionhigh.org/",
          map: "https://maps.google.com/?q=201+E+Chapman+Ave,+Fullerton,+CA+92832"
        },
        {
          name: "Troy High School",
          address: "2200 Dorothy Ln, Fullerton, CA 92831",
          phone: "(714) 626-4400",
          website: "https://www.fjuhsd.org/troy",
          map: "https://maps.google.com/?q=2200+Dorothy+Ln,+Fullerton,+CA+92831"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Rosary Academy (All-Girls Catholic)",
          address: "1340 N Acacia Ave, Fullerton, CA 92831",
          phone: "(714) 879-6302",
          website: "https://www.rosaryacademy.org/",
          map: "https://maps.google.com/?q=1340+N+Acacia+Ave,+Fullerton,+CA+92831"
        },
        {
          name: "Hope International School",
          address: "2500 E Nutwood Ave, Fullerton, CA 92831",
          phone: "(714) 879-3901",
          website: "https://www.hiu.edu/",
          map: "https://maps.google.com/?q=2500+E+Nutwood+Ave,+Fullerton,+CA+92831"
        }
      ]
    }
  ]
},

"ca/garden-grove": {
  city: "Garden Grove",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Garden Grove",
          address: "11222 Acacia Pkwy, Garden Grove, CA 92840",
          phone: "(714) 741-5000",
          website: "https://ggcity.org/",
          map: "https://maps.google.com/?q=11222+Acacia+Pkwy,+Garden+Grove,+CA+92840",
          people: [
            { title: "City Manager", name: "Scott Stiles", phone: "(714) 741-5100", email: "scotts@ggcity.org" },
            { title: "City Clerk", name: "Mindy M. Alvarez", phone: "(714) 741-5040", email: "cityclerk@ggcity.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Garden Grove Police Department",
          address: "11301 Acacia Pkwy, Garden Grove, CA 92840",
          phone: "(714) 741-5704 (Non-Emergency)",
          website: "https://ggcity.org/police",
          map: "https://maps.google.com/?q=11301+Acacia+Pkwy,+Garden+Grove,+CA+92840",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Garden Grove Main Library (OC Public Libraries)",
          address: "11200 Stanford Ave, Garden Grove, CA 92840",
          phone: "(714) 530-0711",
          website: "https://ocpl.org/libraries/garden-grove",
          map: "https://maps.google.com/?q=11200+Stanford+Ave,+Garden+Grove,+CA+92840"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Garden Grove High School",
          address: "11271 Stanford Ave, Garden Grove, CA 92840",
          phone: "(714) 663-6115",
          website: "https://ggusd.us/schools/garden-grove-high-school",
          map: "https://maps.google.com/?q=11271+Stanford+Ave,+Garden+Grove,+CA+92840"
        },
        {
          name: "Pacifica High School",
          address: "6851 Lampson Ave, Garden Grove, CA 92845",
          phone: "(714) 663-6515",
          website: "https://ggusd.us/schools/pacifica-high-school",
          map: "https://maps.google.com/?q=6851+Lampson+Ave,+Garden+Grove,+CA+92845"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Saint Columban School",
          address: "10801 Stanford Ave, Garden Grove, CA 92840",
          phone: "(714) 534-3947",
          website: "https://www.stcolumbanschool.org/",
          map: "https://maps.google.com/?q=10801+Stanford+Ave,+Garden+Grove,+CA+92840"
        },
        {
          name: "Christ Cathedral Academy",
          address: "13280 Chapman Ave, Garden Grove, CA 92840",
          phone: "(714) 663-2330",
          website: "https://www.christcathedralacademy.org/",
          map: "https://maps.google.com/?q=13280+Chapman+Ave,+Garden+Grove,+CA+92840"
        }
      ]
    }
  ]
},
"ca/la-habra": {
  city: "La Habra",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of La Habra",
          address: "110 E La Habra Blvd, La Habra, CA 90631",
          phone: "(562) 383-4000",
          website: "https://www.lahabraca.gov/",
          map: "https://maps.google.com/?q=110+E+La+Habra+Blvd,+La+Habra,+CA+90631",
          people: [
            { title: "City Manager", name: "Steve Carrigan", phone: "(562) 383-4010", email: "scarrigan@lahabraca.gov" },
            { title: "City Clerk", name: "Maria Rangel", phone: "(562) 383-4030", email: "mrangel@lahabraca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "La Habra Police Department",
          address: "150 N Euclid St, La Habra, CA 90631",
          phone: "(562) 383-4300 (Non-Emergency)",
          website: "https://www.lahabraca.gov/154/Police",
          map: "https://maps.google.com/?q=150+N+Euclid+St,+La+Habra,+CA+90631",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "La Habra Library (OC Public Libraries)",
          address: "221 E La Habra Blvd, La Habra, CA 90631",
          phone: "(562) 694-0078",
          website: "https://ocpl.org/libraries/la-habra",
          map: "https://maps.google.com/?q=221+E+La+Habra+Blvd,+La+Habra,+CA+90631"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "La Habra High School",
          address: "801 Highlander Ave, La Habra, CA 90631",
          phone: "(562) 266-5000",
          website: "https://www.fjuhsd.org/lahabra",
          map: "https://maps.google.com/?q=801+Highlander+Ave,+La+Habra,+CA+90631"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Our Lady of Guadalupe School",
          address: "920 W La Habra Blvd, La Habra, CA 90631",
          phone: "(562) 697-8323",
          website: "https://www.olglahabra.org/",
          map: "https://maps.google.com/?q=920+W+La+Habra+Blvd,+La+Habra,+CA+90631"
        }
      ]
    }
  ]
},

"ca/la-palma": {
  city: "La Palma",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of La Palma",
          address: "7822 Walker St, La Palma, CA 90623",
          phone: "(714) 690-3300",
          website: "https://www.cityoflapalma.org/",
          map: "https://maps.google.com/?q=7822+Walker+St,+La+Palma,+CA+90623",
          people: [
            { title: "City Manager", name: "Dominic Lazzaretto", phone: "(714) 690-3300", email: "citymanager@cityoflapalma.org" },
            { title: "City Clerk", name: "Kimberly Kenney", phone: "(714) 690-3334", email: "cityclerk@cityoflapalma.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "La Palma Police Department",
          address: "7792 Walker St, La Palma, CA 90623",
          phone: "(714) 690-3368 (Non-Emergency)",
          website: "https://www.cityoflapalma.org/163/Police-Department",
          map: "https://maps.google.com/?q=7792+Walker+St,+La+Palma,+CA+90623",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "La Palma Library (OC Public Libraries)",
          address: "7842 Walker St, La Palma, CA 90623",
          phone: "(714) 523-3454",
          website: "https://ocpl.org/libraries/la-palma",
          map: "https://maps.google.com/?q=7842+Walker+St,+La+Palma,+CA+90623"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Kennedy High School",
          address: "8281 Walker St, La Palma, CA 90620",
          phone: "(714) 220-4101",
          website: "https://kennedy.auhsd.us/",
          map: "https://maps.google.com/?q=8281+Walker+St,+La+Palma,+CA+90620"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Beacon Day School",
          address: "24 Centerpointe Dr, La Palma, CA 90623",
          phone: "(714) 288-4200",
          website: "https://www.beacondayschool.com/",
          map: "https://maps.google.com/?q=24+Centerpointe+Dr,+La+Palma,+CA+90623"
        }
      ]
    }
  ]
},

"ca/laguna-niguel": {
  city: "Laguna Niguel",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Laguna Niguel",
          address: "30111 Crown Valley Pkwy, Laguna Niguel, CA 92677",
          phone: "(949) 362-4300",
          website: "https://www.cityoflagunaniguel.org/",
          map: "https://maps.google.com/?q=30111+Crown+Valley+Pkwy,+Laguna+Niguel,+CA+92677",
          people: [
            { title: "City Manager", name: "Tamara Letourneau", phone: "(949) 362-4300", email: "tletourneau@cityoflagunaniguel.org" },
            { title: "City Clerk", name: "Lindsay Sholund", phone: "(949) 362-4300", email: "cityclerk@cityoflagunaniguel.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Laguna Niguel Police Services (OC Sheriff)",
          address: "30111 Crown Valley Pkwy, Laguna Niguel, CA 92677",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/laguna-niguel",
          map: "https://maps.google.com/?q=30111+Crown+Valley+Pkwy,+Laguna+Niguel,+CA+92677",
          notes: "Law enforcement services provided under contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Laguna Niguel Library (OC Public Libraries)",
          address: "30341 Crown Valley Pkwy, Laguna Niguel, CA 92677",
          phone: "(949) 249-5252",
          website: "https://ocpl.org/libraries/laguna-niguel",
          map: "https://maps.google.com/?q=30341+Crown+Valley+Pkwy,+Laguna+Niguel,+CA+92677"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Aliso Niguel High School",
          address: "28000 Wolverine Way, Aliso Viejo, CA 92656",
          phone: "(949) 831-5590",
          website: "https://anhs-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=28000+Wolverine+Way,+Aliso+Viejo,+CA+92656"
        },
        {
          name: "Niguel Hills Middle School",
          address: "29070 Paseo Escuela, Laguna Niguel, CA 92677",
          phone: "(949) 234-5360",
          website: "https://nhms-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=29070+Paseo+Escuela,+Laguna+Niguel,+CA+92677"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. Anne School (Catholic, K–8)",
          address: "32451 Bear Brand Rd, Laguna Niguel, CA 92677",
          phone: "(949) 276-6700",
          website: "https://www.st-anne.org/",
          map: "https://maps.google.com/?q=32451+Bear+Brand+Rd,+Laguna+Niguel,+CA+92677"
        }
      ]
    }
  ]
},
"ca/laguna-woods": {
  city: "Laguna Woods",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Laguna Woods",
          address: "24264 El Toro Rd, Laguna Woods, CA 92637",
          phone: "(949) 639-0500",
          website: "https://www.cityoflagunawoods.org/",
          map: "https://maps.google.com/?q=24264+El+Toro+Rd,+Laguna+Woods,+CA+92637",
          people: [
            { title: "City Manager", name: "Christopher Macon", phone: "(949) 639-0500", email: "cmacon@cityoflagunawoods.org" },
            { title: "City Clerk", name: "Jennifer M. Cabrera", phone: "(949) 639-0500", email: "jcabrera@cityoflagunawoods.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Laguna Woods Police Services (OC Sheriff)",
          address: "24264 El Toro Rd, Laguna Woods, CA 92637",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/laguna-woods",
          map: "https://maps.google.com/?q=24264+El+Toro+Rd,+Laguna+Woods,+CA+92637",
          notes: "Law enforcement provided by contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Laguna Woods Library (OC Public Libraries)",
          address: "24264 El Toro Rd, Laguna Woods, CA 92637",
          phone: "(949) 639-0500",
          website: "https://ocpl.org/libraries/laguna-woods",
          map: "https://maps.google.com/?q=24264+El+Toro+Rd,+Laguna+Woods,+CA+92637"
        }
      ]
    },
    {
      category: "Public School",
      items: [] // Laguna Woods is mostly senior community; schools are outside the city.
    },
    {
      category: "Private",
      items: []
    }
  ]
},

"ca/lake-forest": {
  city: "Lake Forest",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Lake Forest",
          address: "100 Civic Center Dr, Lake Forest, CA 92630",
          phone: "(949) 461-3400",
          website: "https://www.lakeforestca.gov/",
          map: "https://maps.google.com/?q=100+Civic+Center+Dr,+Lake+Forest,+CA+92630",
          people: [
            { title: "City Manager", name: "Deborah Rose", phone: "(949) 461-3400", email: "citymanager@lakeforestca.gov" },
            { title: "City Clerk", name: "Stephanie D. Smith", phone: "(949) 461-3420", email: "cityclerk@lakeforestca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Lake Forest Police Services (OC Sheriff)",
          address: "20202 Windrow Dr, Lake Forest, CA 92630",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/lake-forest",
          map: "https://maps.google.com/?q=20202+Windrow+Dr,+Lake+Forest,+CA+92630",
          notes: "Law enforcement provided by contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "El Toro Library (OC Public Libraries)",
          address: "24672 Raymond Way, Lake Forest, CA 92630",
          phone: "(949) 855-8173",
          website: "https://ocpl.org/libraries/el-toro",
          map: "https://maps.google.com/?q=24672+Raymond+Way,+Lake+Forest,+CA+92630"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "El Toro High School",
          address: "25255 Toledo Way, Lake Forest, CA 92630",
          phone: "(949) 586-6333",
          website: "https://www.svusd.org/schools/high-schools/el-toro",
          map: "https://maps.google.com/?q=25255+Toledo+Way,+Lake+Forest,+CA+92630"
        },
        {
          name: "Serrano Intermediate School",
          address: "24642 Serrano Rd, Lake Forest, CA 92630",
          phone: "(949) 586-3221",
          website: "https://www.svusd.org/schools/intermediate-schools/serrano",
          map: "https://maps.google.com/?q=24642+Serrano+Rd,+Lake+Forest,+CA+92630"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Heritage Oak Private Education",
          address: "16971 Imperial Hwy, Lake Forest, CA 92630",
          phone: "(949) 598-9166",
          website: "https://www.heritageoak.org/",
          map: "https://maps.google.com/?q=16971+Imperial+Hwy,+Lake+Forest,+CA+92630"
        }
      ]
    }
  ]
},

"ca/los-alamitos": {
  city: "Los Alamitos",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Los Alamitos",
          address: "3191 Katella Ave, Los Alamitos, CA 90720",
          phone: "(562) 431-3538",
          website: "https://cityoflosalamitos.org/",
          map: "https://maps.google.com/?q=3191+Katella+Ave,+Los+Alamitos,+CA+90720",
          people: [
            { title: "City Manager", name: "Chet Simmons", phone: "(562) 431-3538", email: "csimmons@cityoflosalamitos.org" },
            { title: "City Clerk", name: "Windmera Quintanar", phone: "(562) 431-3538", email: "wquintanar@cityoflosalamitos.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Los Alamitos Police Department",
          address: "3201 Katella Ave, Los Alamitos, CA 90720",
          phone: "(562) 431-2255 (Non-Emergency)",
          website: "https://cityoflosalamitos.org/184/Police",
          map: "https://maps.google.com/?q=3201+Katella+Ave,+Los+Alamitos,+CA+90720",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Los Alamitos-Rossmoor Library (OC Public Libraries)",
          address: "12700 Montecito Rd, Seal Beach, CA 90740",
          phone: "(562) 430-1048",
          website: "https://ocpl.org/libraries/los-alamitos-rossmoor",
          map: "https://maps.google.com/?q=12700+Montecito+Rd,+Seal+Beach,+CA+90740"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Los Alamitos High School",
          address: "3591 W Cerritos Ave, Los Alamitos, CA 90720",
          phone: "(562) 799-4780",
          website: "https://lahs.losal.org/",
          map: "https://maps.google.com/?q=3591+W+Cerritos+Ave,+Los+Alamitos,+CA+90720"
        },
        {
          name: "Oak Middle School",
          address: "10821 Oak St, Los Alamitos, CA 90720",
          phone: "(562) 799-4740",
          website: "https://oak.losal.org/",
          map: "https://maps.google.com/?q=10821+Oak+St,+Los+Alamitos,+CA+90720"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Saint Hedwig Catholic School",
          address: "3620 Myra Ave, Los Alamitos, CA 90720",
          phone: "(562) 598-0131",
          website: "https://sthedwigk8.org/",
          map: "https://maps.google.com/?q=3620+Myra+Ave,+Los+Alamitos,+CA+90720"
        }
      ]
    }
  ]
},
"ca/orange": {
  city: "Orange",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Orange",
          address: "300 E Chapman Ave, Orange, CA 92866",
          phone: "(714) 744-2225",
          website: "https://www.cityoforange.org/",
          map: "https://maps.google.com/?q=300+E+Chapman+Ave,+Orange,+CA+92866",
          people: [
            { title: "City Manager", name: "Tom Hatch", phone: "(714) 744-2225", email: "thatch@cityoforange.org" },
            { title: "City Clerk", name: "Pamela Coleman", phone: "(714) 744-5500", email: "pcn@cityoforange.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Orange Police Department",
          address: "1107 N Batavia St, Orange, CA 92867",
          phone: "(714) 744-7444 (Non-Emergency)",
          website: "https://www.cityoforange.org/194/Police",
          map: "https://maps.google.com/?q=1107+N+Batavia+St,+Orange,+CA+92867",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Orange Public Library & History Center",
          address: "407 E Chapman Ave, Orange, CA 92866",
          phone: "(714) 288-2400",
          website: "https://www.cityoforange.org/1235/Library",
          map: "https://maps.google.com/?q=407+E+Chapman+Ave,+Orange,+CA+92866"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Orange High School",
          address: "525 N Shaffer St, Orange, CA 92867",
          phone: "(714) 997-6211",
          website: "https://www.orangeusd.org/ohs",
          map: "https://maps.google.com/?q=525+N+Shaffer+St,+Orange,+CA+92867"
        },
        {
          name: "El Modena High School",
          address: "3920 Spring St, Orange, CA 92869",
          phone: "(714) 997-6331",
          website: "https://www.orangeusd.org/emhs",
          map: "https://maps.google.com/?q=3920+Spring+St,+Orange,+CA+92869"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Orange Lutheran High School",
          address: "2222 N Santiago Blvd, Orange, CA 92867",
          phone: "(714) 998-5151",
          website: "https://lhsoc.org/",
          map: "https://maps.google.com/?q=2222+N+Santiago+Blvd,+Orange,+CA+92867"
        }
      ]
    }
  ]
},

"ca/placentia": {
  city: "Placentia",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Placentia",
          address: "401 E Chapman Ave, Placentia, CA 92870",
          phone: "(714) 993-8117",
          website: "https://www.placentia.org/",
          map: "https://maps.google.com/?q=401+E+Chapman+Ave,+Placentia,+CA+92870",
          people: [
            { title: "City Administrator", name: "Damien R. Arrula", phone: "(714) 993-8171", email: "darrula@placentia.org" },
            { title: "City Clerk", name: "Veronica Ortiz", phone: "(714) 993-8231", email: "vortiz@placentia.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Placentia Police Department",
          address: "401 E Chapman Ave, Placentia, CA 92870",
          phone: "(714) 993-8164 (Non-Emergency)",
          website: "https://www.placentia.org/75/Police-Department",
          map: "https://maps.google.com/?q=401+E+Chapman+Ave,+Placentia,+CA+92870",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Placentia Library District",
          address: "411 E Chapman Ave, Placentia, CA 92870",
          phone: "(714) 528-1906",
          website: "https://www.placentialibrary.org/",
          map: "https://maps.google.com/?q=411+E+Chapman+Ave,+Placentia,+CA+92870"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Valencia High School",
          address: "500 N Bradford Ave, Placentia, CA 92870",
          phone: "(714) 996-4970",
          website: "https://www.pylusd.org/valencia",
          map: "https://maps.google.com/?q=500+N+Bradford+Ave,+Placentia,+CA+92870"
        },
        {
          name: "El Dorado High School",
          address: "1651 Valencia Ave, Placentia, CA 92870",
          phone: "(714) 986-7580",
          website: "https://www.pylusd.org/eldorado",
          map: "https://maps.google.com/?q=1651+Valencia+Ave,+Placentia,+CA+92870"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Calvary Chapel Schools - Placentia",
          address: "101 S Bradford Ave, Placentia, CA 92870",
          phone: "(714) 993-4801",
          website: "https://ccschools.org/",
          map: "https://maps.google.com/?q=101+S+Bradford+Ave,+Placentia,+CA+92870"
        }
      ]
    }
  ]
},

"ca/rancho-santa-margarita": {
  city: "Rancho Santa Margarita",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Rancho Santa Margarita",
          address: "22112 El Paseo, Rancho Santa Margarita, CA 92688",
          phone: "(949) 635-1800",
          website: "https://www.cityofrsm.org/",
          map: "https://maps.google.com/?q=22112+El+Paseo,+Rancho+Santa+Margarita,+CA+92688",
          people: [
            { title: "City Manager", name: "Jennifer Cervantez", phone: "(949) 635-1800", email: "jcervantez@cityofrsm.org" },
            { title: "City Clerk", name: "Amy Diaz", phone: "(949) 635-1806", email: "adiaz@cityofrsm.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Rancho Santa Margarita Police Services (OC Sheriff)",
          address: "22112 El Paseo, Rancho Santa Margarita, CA 92688",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/rancho-santa-margarita",
          map: "https://maps.google.com/?q=22112+El+Paseo,+Rancho+Santa+Margarita,+CA+92688",
          notes: "Law enforcement provided under contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Rancho Santa Margarita Library (OC Public Libraries)",
          address: "30902 La Promesa, Rancho Santa Margarita, CA 92688",
          phone: "(949) 459-6094",
          website: "https://ocpl.org/libraries/rancho-santa-margarita",
          map: "https://maps.google.com/?q=30902+La+Promesa,+Rancho+Santa+Margarita,+CA+92688"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Trabuco Hills High School",
          address: "27501 Mustang Run, Mission Viejo, CA 92691",
          phone: "(949) 768-1934",
          website: "https://www.svusd.org/schools/high-schools/trabuco-hills",
          map: "https://maps.google.com/?q=27501+Mustang+Run,+Mission+Viejo,+CA+92691"
        },
        {
          name: "Santa Margarita Catholic High School",
          address: "22062 Antonio Pkwy, Rancho Santa Margarita, CA 92688",
          phone: "(949) 766-6000",
          website: "https://www.smhs.org/",
          map: "https://maps.google.com/?q=22062+Antonio+Pkwy,+Rancho+Santa+Margarita,+CA+92688"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "St. John’s Episcopal School",
          address: "30382 Via Con Dios, Rancho Santa Margarita, CA 92688",
          phone: "(949) 858-5144",
          website: "https://www.stjohns-es.org/",
          map: "https://maps.google.com/?q=30382+Via+Con+Dios,+Rancho+Santa+Margarita,+CA+92688"
        }
      ]
    }
  ]
},
"ca/san-juan-capistrano": {
  city: "San Juan Capistrano",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of San Juan Capistrano",
          address: "32400 Paseo Adelanto, San Juan Capistrano, CA 92675",
          phone: "(949) 493-1171",
          website: "https://sanjuancapistrano.org/",
          map: "https://maps.google.com/?q=32400+Paseo+Adelanto,+San+Juan+Capistrano,+CA+92675",
          people: [
            { title: "City Manager", name: "Ben Siegel", phone: "(949) 443-6314", email: "bsiegel@sanjuancapistrano.org" },
            { title: "City Clerk", name: "Maria Morris", phone: "(949) 493-1171", email: "mmorris@sanjuancapistrano.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "San Juan Capistrano Police Services (OC Sheriff)",
          address: "32506 Paseo Adelanto, San Juan Capistrano, CA 92675",
          phone: "(949) 770-6011 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/san-juan-capistrano",
          map: "https://maps.google.com/?q=32506+Paseo+Adelanto,+San+Juan+Capistrano,+CA+92675",
          notes: "Law enforcement provided under contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "San Juan Capistrano Library (OC Public Libraries)",
          address: "31495 El Camino Real, San Juan Capistrano, CA 92675",
          phone: "(949) 493-1752",
          website: "https://ocpl.org/libraries/san-juan-capistrano",
          map: "https://maps.google.com/?q=31495+El+Camino+Real,+San+Juan+Capistrano,+CA+92675"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "San Juan Hills High School",
          address: "29211 Stallion Ridge, San Juan Capistrano, CA 92675",
          phone: "(949) 234-5900",
          website: "https://sjhhs-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=29211+Stallion+Ridge,+San+Juan+Capistrano,+CA+92675"
        },
        {
          name: "Marco Forster Middle School",
          address: "25601 Camino Del Avion, San Juan Capistrano, CA 92675",
          phone: "(949) 234-5900",
          website: "https://mforster-capousd-ca.schoolloop.com/",
          map: "https://maps.google.com/?q=25601+Camino+Del+Avion,+San+Juan+Capistrano,+CA+92675"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Capistrano Valley Christian Schools",
          address: "32032 Del Obispo St, San Juan Capistrano, CA 92675",
          phone: "(949) 493-3918",
          website: "https://www.cvcs.org/",
          map: "https://maps.google.com/?q=32032+Del+Obispo+St,+San+Juan+Capistrano,+CA+92675"
        },
        {
          name: "JSerra Catholic High School",
          address: "26351 Junipero Serra Rd, San Juan Capistrano, CA 92675",
          phone: "(949) 493-9307",
          website: "https://www.jserra.org/",
          map: "https://maps.google.com/?q=26351+Junipero+Serra+Rd,+San+Juan+Capistrano,+CA+92675"
        }
      ]
    }
  ]
},

"ca/santa-ana": {
  city: "Santa Ana",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Santa Ana",
          address: "20 Civic Center Plaza, Santa Ana, CA 92701",
          phone: "(714) 647-5400",
          website: "https://www.santa-ana.org/",
          map: "https://maps.google.com/?q=20+Civic+Center+Plaza,+Santa+Ana,+CA+92701",
          people: [
            { title: "City Manager", name: "Kristine Ridge", phone: "(714) 647-5200", email: "kridge@santa-ana.org" },
            { title: "City Clerk", name: "Daisy Gomez", phone: "(714) 647-6520", email: "dgomez@santa-ana.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Santa Ana Police Department",
          address: "60 Civic Center Plaza, Santa Ana, CA 92701",
          phone: "(714) 245-8665 (Non-Emergency)",
          website: "https://www.santa-ana.org/pd",
          map: "https://maps.google.com/?q=60+Civic+Center+Plaza,+Santa+Ana,+CA+92701",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Santa Ana Public Library",
          address: "26 Civic Center Plaza, Santa Ana, CA 92701",
          phone: "(714) 647-5250",
          website: "https://www.santa-ana.org/library",
          map: "https://maps.google.com/?q=26+Civic+Center+Plaza,+Santa+Ana,+CA+92701"
        }
      ]
    },
    {
      category: "County Government (Orange County)",
      items: [
        {
          name: "Orange County Hall of Administration",
          address: "333 W Santa Ana Blvd, Santa Ana, CA 92701",
          phone: "(714) 834-5400",
          website: "https://ocgov.com/",
          map: "https://maps.google.com/?q=333+W+Santa+Ana+Blvd,+Santa+Ana,+CA+92701",
          people: [
            { title: "County Executive Officer", name: "Frank Kim" },
            { title: "Clerk of the Board", name: "Susan Novak" }
          ]
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Santa Ana High School",
          address: "520 W Walnut St, Santa Ana, CA 92701",
          phone: "(714) 567-4900",
          website: "https://www.sausd.us/sahs",
          map: "https://maps.google.com/?q=520+W+Walnut+St,+Santa+Ana,+CA+92701"
        },
        {
          name: "Century High School",
          address: "1401 S Grand Ave, Santa Ana, CA 92705",
          phone: "(714) 568-7000",
          website: "https://www.sausd.us/century",
          map: "https://maps.google.com/?q=1401+S+Grand+Ave,+Santa+Ana,+CA+92705"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Mater Dei High School",
          address: "1202 W Edinger Ave, Santa Ana, CA 92707",
          phone: "(714) 754-7711",
          website: "https://www.materdei.org/",
          map: "https://maps.google.com/?q=1202+W+Edinger+Ave,+Santa+Ana,+CA+92707"
        }
      ]
    }
  ]
},

"ca/seal-beach": {
  city: "Seal Beach",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Seal Beach",
          address: "211 8th St, Seal Beach, CA 90740",
          phone: "(562) 431-2527",
          website: "https://www.sealbeachca.gov/",
          map: "https://maps.google.com/?q=211+8th+St,+Seal+Beach,+CA+90740",
          people: [
            { title: "City Manager", name: "Jill Ingram", phone: "(562) 431-2527", email: "jingram@sealbeachca.gov" },
            { title: "City Clerk", name: "Gloria Harper", phone: "(562) 431-2527", email: "gharper@sealbeachca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Seal Beach Police Department",
          address: "911 Seal Beach Blvd, Seal Beach, CA 90740",
          phone: "(562) 799-4100 (Non-Emergency)",
          website: "https://www.sealbeachca.gov/departments/police",
          map: "https://maps.google.com/?q=911+Seal+Beach+Blvd,+Seal+Beach,+CA+90740",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Seal Beach Mary Wilson Library (OC Public Libraries)",
          address: "707 Electric Ave, Seal Beach, CA 90740",
          phone: "(562) 431-3584",
          website: "https://ocpl.org/libraries/seal-beach",
          map: "https://maps.google.com/?q=707+Electric+Ave,+Seal+Beach,+CA+90740"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Los Alamitos High School (serves Seal Beach)",
          address: "3591 W Cerritos Ave, Los Alamitos, CA 90720",
          phone: "(562) 799-4780",
          website: "https://lahs.losal.org/",
          map: "https://maps.google.com/?q=3591+W+Cerritos+Ave,+Los+Alamitos,+CA+90720"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Saint Hedwig Catholic School",
          address: "3620 Myra Ave, Los Alamitos, CA 90720",
          phone: "(562) 598-0131",
          website: "https://sthedwigk8.org/",
          map: "https://maps.google.com/?q=3620+Myra+Ave,+Los+Alamitos,+CA+90720"
        }
      ]
    }
  ]
},
"ca/stanton": {
  city: "Stanton",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Stanton",
          address: "7800 Katella Ave, Stanton, CA 90680",
          phone: "(714) 379-9222",
          website: "https://www.stantonca.gov/",
          map: "https://maps.google.com/?q=7800+Katella+Ave,+Stanton,+CA+90680",
          people: [
            { title: "City Manager", name: "Jarad Hildenbrand", phone: "(714) 890-4270", email: "jhildenbrand@stantonca.gov" },
            { title: "City Clerk", name: "Patricia Vasquez", phone: "(714) 890-4246", email: "pvasquez@stantonca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Stanton Police Services (OC Sheriff)",
          address: "11100 Cedar St, Stanton, CA 90680",
          phone: "(714) 647-7000 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/stanton",
          map: "https://maps.google.com/?q=11100+Cedar+St,+Stanton,+CA+90680",
          notes: "Law enforcement provided by contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Stanton Library (OC Public Libraries)",
          address: "7850 Katella Ave, Stanton, CA 90680",
          phone: "(714) 898-3302",
          website: "https://ocpl.org/libraries/stanton",
          map: "https://maps.google.com/?q=7850+Katella+Ave,+Stanton,+CA+90680"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Stanton Elementary School",
          address: "7850 Cerritos Ave, Stanton, CA 90680",
          phone: "(714) 663-6124",
          website: "https://www.ggusd.us/schools/stanton-elementary",
          map: "https://maps.google.com/?q=7850+Cerritos+Ave,+Stanton,+CA+90680"
        }
      ]
    },
    {
      category: "Private",
      items: []
    }
  ]
},

"ca/tustin": {
  city: "Tustin",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Tustin",
          address: "300 Centennial Way, Tustin, CA 92780",
          phone: "(714) 573-3000",
          website: "https://www.tustinca.org/",
          map: "https://maps.google.com/?q=300+Centennial+Way,+Tustin,+CA+92780",
          people: [
            { title: "City Manager", name: "Matthew West", phone: "(714) 573-3012", email: "mwest@tustinca.org" },
            { title: "City Clerk", name: "Erica G. Roeder", phone: "(714) 573-3026", email: "cityclerk@tustinca.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Tustin Police Department",
          address: "300 Centennial Way, Tustin, CA 92780",
          phone: "(714) 573-3200 (Non-Emergency)",
          website: "https://www.tustinca.org/196/Police-Department",
          map: "https://maps.google.com/?q=300+Centennial+Way,+Tustin,+CA+92780",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Tustin Library (OC Public Libraries)",
          address: "345 E Main St, Tustin, CA 92780",
          phone: "(714) 544-7725",
          website: "https://ocpl.org/libraries/tustin",
          map: "https://maps.google.com/?q=345+E+Main+St,+Tustin,+CA+92780"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Tustin High School",
          address: "1171 El Camino Real, Tustin, CA 92780",
          phone: "(714) 730-7414",
          website: "https://www.tustin.k12.ca.us/tustin",
          map: "https://maps.google.com/?q=1171+El+Camino+Real,+Tustin,+CA+92780"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Red Hill Lutheran School",
          address: "13200 Red Hill Ave, Tustin, CA 92780",
          phone: "(714) 544-3132",
          website: "https://www.redhillschool.org/",
          map: "https://maps.google.com/?q=13200+Red+Hill+Ave,+Tustin,+CA+92780"
        }
      ]
    }
  ]
},

"ca/villa-park": {
  city: "Villa Park",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Villa Park",
          address: "17855 Santiago Blvd, Villa Park, CA 92861",
          phone: "(714) 998-1500",
          website: "https://www.villapark.org/",
          map: "https://maps.google.com/?q=17855+Santiago+Blvd,+Villa+Park,+CA+92861",
          people: [
            { title: "City Manager", name: "Steve Franks", phone: "(714) 998-1500", email: "sfranks@villapark.org" },
            { title: "City Clerk", name: "Penelope Kuehl", phone: "(714) 998-1500", email: "pkuehl@villapark.org" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Villa Park Police Services (OC Sheriff)",
          address: "17855 Santiago Blvd, Villa Park, CA 92861",
          phone: "(714) 647-7000 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/villa-park",
          map: "https://maps.google.com/?q=17855+Santiago+Blvd,+Villa+Park,+CA+92861",
          notes: "Law enforcement provided by contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Villa Park Library (OC Public Libraries)",
          address: "17865 Santiago Blvd, Villa Park, CA 92861",
          phone: "(714) 998-0861",
          website: "https://ocpl.org/libraries/villa-park",
          map: "https://maps.google.com/?q=17865+Santiago+Blvd,+Villa+Park,+CA+92861"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Villa Park High School",
          address: "18042 Taft Ave, Villa Park, CA 92861",
          phone: "(714) 532-8020",
          website: "https://www.orangeusd.org/vphs",
          map: "https://maps.google.com/?q=18042+Taft+Ave,+Villa+Park,+CA+92861"
        }
      ]
    },
    {
      category: "Private",
      items: []
    }
  ]
},

"ca/westminster": {
  city: "Westminster",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Westminster",
          address: "8200 Westminster Blvd, Westminster, CA 92683",
          phone: "(714) 898-3311",
          website: "https://www.westminster-ca.gov/",
          map: "https://maps.google.com/?q=8200+Westminster+Blvd,+Westminster,+CA+92683",
          people: [
            { title: "City Manager", name: "Christine Cordon", phone: "(714) 548-3172", email: "ccordon@westminster-ca.gov" },
            { title: "City Clerk", name: "Donald Cortez", phone: "(714) 548-3237", email: "dcortez@westminster-ca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Westminster Police Department",
          address: "8200 Westminster Blvd, Westminster, CA 92683",
          phone: "(714) 548-3200 (Non-Emergency)",
          website: "https://www.westminster-ca.gov/departments/police",
          map: "https://maps.google.com/?q=8200+Westminster+Blvd,+Westminster,+CA+92683",
          notes: "For emergencies dial 911"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Westminster Library (OC Public Libraries)",
          address: "8180 13th St, Westminster, CA 92683",
          phone: "(714) 893-5057",
          website: "https://ocpl.org/libraries/westminster",
          map: "https://maps.google.com/?q=8180+13th+St,+Westminster,+CA+92683"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Westminster High School",
          address: "14325 Goldenwest St, Westminster, CA 92683",
          phone: "(714) 893-1381",
          website: "https://www.hbuhsd.edu/whs",
          map: "https://maps.google.com/?q=14325+Goldenwest+St,+Westminster,+CA+92683"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "La Quinta High School (Private/VN community)",
          address: "10372 McFadden Ave, Westminster, CA 92683",
          phone: "(714) 663-6336",
          website: "https://www.ggusd.us/schools/la-quinta-high-school",
          map: "https://maps.google.com/?q=10372+McFadden+Ave,+Westminster,+CA+92683"
        }
      ]
    }
  ]
},

"ca/yorba-linda": {
  city: "Yorba Linda",
  state: "California",
  sections: [
    {
      category: "City Hall",
      items: [
        {
          name: "City of Yorba Linda",
          address: "4845 Casa Loma Ave, Yorba Linda, CA 92886",
          phone: "(714) 961-7100",
          website: "https://www.yorbalindaca.gov/",
          map: "https://maps.google.com/?q=4845+Casa+Loma+Ave,+Yorba+Linda,+CA+92886",
          people: [
            { title: "City Manager", name: "Mark Pulone", phone: "(714) 961-7110", email: "mpulone@yorbalindaca.gov" },
            { title: "City Clerk", name: "Marlene Garcia", phone: "(714) 961-7150", email: "mgarcia@yorbalindaca.gov" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Yorba Linda Police Services (OC Sheriff)",
          address: "20994 Yorba Linda Blvd, Yorba Linda, CA 92886",
          phone: "(714) 647-7000 (Non-Emergency)",
          website: "https://www.ocsheriff.gov/patrol-areas/yorba-linda",
          map: "https://maps.google.com/?q=20994+Yorba+Linda+Blvd,+Yorba+Linda,+CA+92886",
          notes: "Law enforcement provided under contract with OCSD"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Yorba Linda Public Library",
          address: "4852 Lakeview Ave, Yorba Linda, CA 92886",
          phone: "(714) 777-2873",
          website: "https://www.ylpl.org/",
          map: "https://maps.google.com/?q=4852+Lakeview+Ave,+Yorba+Linda,+CA+92886"
        }
      ]
    },
    {
      category: "Public School",
      items: [
        {
          name: "Yorba Linda High School",
          address: "19900 Bastanchury Rd, Yorba Linda, CA 92886",
          phone: "(714) 986-7500",
          website: "https://www.pylusd.org/ylhs",
          map: "https://maps.google.com/?q=19900+Bastanchury+Rd,+Yorba+Linda,+CA+92886"
        },
        {
          name: "Esperanza High School",
          address: "1830 Kellogg Dr, Anaheim, CA 92807",
          phone: "(714) 986-7540",
          website: "https://www.pylusd.org/esperanza",
          map: "https://maps.google.com/?q=1830+Kellogg+Dr,+Anaheim,+CA+92807"
        }
      ]
    },
    {
      category: "Private",
      items: [
        {
          name: "Heritage Oak Private School",
          address: "16971 Imperial Hwy, Yorba Linda, CA 92886",
          phone: "(714) 524-1350",
          website: "https://www.heritageoak.org/",
          map: "https://maps.google.com/?q=16971+Imperial+Hwy,+Yorba+Linda,+CA+92886"
        }
      ]
    }
  ]
},
"nj/bergen-county": {
  city: "Bergen County",
  state: "New Jersey",
  sections: [
    {
      category: "County Government",
      items: [
        {
          name: "Bergen County Administration Building",
          address: "One Bergen County Plaza, Hackensack, NJ 07601",
          phone: "(201) 336-7300",
          website: "https://www.co.bergen.nj.us/",
          map: "https://maps.google.com/?q=One+Bergen+County+Plaza,+Hackensack,+NJ+07601",
          people: [
            { title: "County Executive", name: "James J. Tedesco III", phone: "(201) 336-7300" },
            { title: "Clerk", name: "John S. Hogan", phone: "(201) 336-7000" }
          ]
        }
      ]
    },
    {
      category: "Police Services",
      items: [
        {
          name: "Bergen County Sheriff's Office",
          address: "10 Main Street, Hackensack, NJ 07601",
          phone: "(201) 646-2200",
          website: "https://www.bcsd.us/",
          map: "https://maps.google.com/?q=10+Main+Street,+Hackensack,+NJ+07601",
          notes: "Sheriff: Anthony Cureton"
        }
      ]
    },
    {
      category: "Library",
      items: [
        {
          name: "Bergen County Cooperative Library System (BCCLS)",
          address: "810 Main Street, Hackensack, NJ 07601",
          phone: "(201) 488-7830",
          website: "https://www.bccls.org/",
          map: "https://maps.google.com/?q=810+Main+Street,+Hackensack,+NJ+07601"
        }
      ]
    },
    {
      category: "College",
      items: [
        {
          name: "Bergen Community College",
          address: "400 Paramus Road, Paramus, NJ 07652",
          phone: "(201) 447-7100",
          website: "https://bergen.edu/",
          map: "https://maps.google.com/?q=400+Paramus+Road,+Paramus,+NJ+07652"
        }
      ]
    }
  ]
},
"nj/state": {
    "city": "New Jersey",
    "state": "New Jersey",
    "sections": [
      {
        "category": "State Government",
        "items": [
          {
            "name": "New Jersey State Capitol",
            "address": "125 W State St, Trenton, NJ 08608",
            "phone": "(609) 292-4840",
            "website": "https://www.nj.gov/",
            "map": "https://maps.google.com/?q=125+W+State+St,+Trenton,+NJ+08608",
            "people": [
              { "title": "Governor", "name": "Phil Murphy", "phone": "(609) 292-6000" },
              { "title": "Lieutenant Governor", "name": "Tahesha Way" }
            ]
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New Jersey State Library",
            "address": "185 W State St, Trenton, NJ 08608",
            "phone": "(609) 278-2640",
            "website": "https://www.njstatelib.org/",
            "map": "https://maps.google.com/?q=185+W+State+St,+Trenton,+NJ+08608"
          }
        ]
      },
      {
        "category": "University",
        "items": [
          {
            "name": "Rutgers, The State University of New Jersey",
            "address": "83 Somerset St, New Brunswick, NJ 08901",
            "phone": "(732) 445-4636",
            "website": "https://www.rutgers.edu/",
            "map": "https://maps.google.com/?q=83+Somerset+St,+New+Brunswick,+NJ+08901"
          }
        ]
      }
    ]
  },
  "nj/bergen-county": {
    "city": "Bergen County",
    "state": "New Jersey",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Bergen County Administration Building",
            "address": "One Bergen County Plaza, Hackensack, NJ 07601",
            "phone": "(201) 336-7300",
            "website": "https://www.co.bergen.nj.us/",
            "map": "https://maps.google.com/?q=One+Bergen+County+Plaza,+Hackensack,+NJ+07601",
            "people": [
              { "title": "County Executive", "name": "James J. Tedesco III" },
              { "title": "Clerk", "name": "John S. Hogan" }
            ]
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "Bergen County Sheriff's Office",
            "address": "10 Main Street, Hackensack, NJ 07601",
            "phone": "(201) 646-2200",
            "website": "https://www.bcsd.us/",
            "map": "https://maps.google.com/?q=10+Main+Street,+Hackensack,+NJ+07601",
            "notes": "Sheriff: Anthony Cureton"
          }
        ]
      }
    ]
  },
  "nj/essex-county": {
    "city": "Essex County",
    "state": "New Jersey",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Essex County Hall of Records",
            "address": "465 Dr. Martin Luther King Jr. Blvd, Newark, NJ 07102",
            "phone": "(973) 621-4400",
            "website": "https://essexcountynj.org/",
            "map": "https://maps.google.com/?q=465+Dr+Martin+Luther+King+Jr+Blvd,+Newark,+NJ+07102",
            "people": [
              { "title": "County Executive", "name": "Joseph N. DiVincenzo Jr." }
            ]
          }
        ]
      }
    ]
  },
  "nj/hudson-county": {
    "city": "Hudson County",
    "state": "New Jersey",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Hudson County Plaza",
            "address": "257 Cornelison Ave, Jersey City, NJ 07302",
            "phone": "(201) 795-6000",
            "website": "https://www.hudsoncountynj.org/",
            "map": "https://maps.google.com/?q=257+Cornelison+Ave,+Jersey+City,+NJ+07302",
            "people": [
              { "title": "County Executive", "name": "Craig Guy" }
            ]
          }
        ]
      }
    ]
  },
  "nj/newark": {
    "city": "Newark",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "City of Newark",
            "address": "920 Broad St, Newark, NJ 07102",
            "phone": "(973) 733-6400",
            "website": "https://www.newarknj.gov/",
            "map": "https://maps.google.com/?q=920+Broad+St,+Newark,+NJ+07102",
            "people": [
              { "title": "Mayor", "name": "Ras J. Baraka", "phone": "(973) 733-6400" }
            ]
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "Newark Police Division",
            "address": "480 Clinton Ave, Newark, NJ 07108",
            "phone": "(973) 733-6000",
            "website": "https://npd.newarkpublicsafety.org/",
            "map": "https://maps.google.com/?q=480+Clinton+Ave,+Newark,+NJ+07108"
          }
        ]
      }
    ]
  },
  "ny/state": {
    "city": "New York State",
    "state": "New York",
    "sections": [
      {
        "category": "State Government",
        "items": [
          {
            "name": "New York State Capitol",
            "address": "State St and Washington Ave, Albany, NY 12224",
            "phone": "(518) 474-8390",
            "website": "https://www.ny.gov/",
            "map": "https://maps.google.com/?q=State+St+and+Washington+Ave,+Albany,+NY+12224",
            "people": [
              { "title": "Governor", "name": "Kathy Hochul" },
              { "title": "Lt. Governor", "name": "Antonio Delgado" }
            ]
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York State Library",
            "address": "222 Madison Ave, Albany, NY 12230",
            "phone": "(518) 474-5355",
            "website": "http://www.nysl.nysed.gov/",
            "map": "https://maps.google.com/?q=222+Madison+Ave,+Albany,+NY+12230"
          }
        ]
      }
    ]
  },

  "ny/new-york-county": {
    "city": "New York County (Manhattan)",
    "state": "New York",
    "sections": [
      {
        "category": "County/Borough Government",
        "items": [
          {
            "name": "Manhattan Borough Hall / Office of the Borough President",
            "address": "1 Centre St, New York, NY 10007",
            "phone": "(212) 669-8300",
            "website": "https://manhattanbp.nyc.gov/",
            "map": "https://maps.google.com/?q=1+Centre+St,+New+York,+NY+10007"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "New York City Police Department (NYPD)",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (Info) • 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038",
            "notes": "For local matters, contact your precinct; non-emergency city services: 311."
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York Public Library (NYPL) – Main Branch",
            "address": "476 5th Ave, New York, NY 10018",
            "phone": "(917) 275-6975",
            "website": "https://www.nypl.org/",
            "map": "https://maps.google.com/?q=476+5th+Ave,+New+York,+NY+10018"
          }
        ]
      }
    ]
  },

  "ny/kings-county": {
    "city": "Kings County (Brooklyn)",
    "state": "New York",
    "sections": [
      {
        "category": "County/Borough Government",
        "items": [
          {
            "name": "Brooklyn Borough Hall",
            "address": "209 Joralemon St, Brooklyn, NY 11201",
            "phone": "(718) 802-3700",
            "website": "https://www.brooklyn-usa.org/",
            "map": "https://maps.google.com/?q=209+Joralemon+St,+Brooklyn,+NY+11201"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "NYPD – Brooklyn Borough (Multiple Precincts)",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (Info) • 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038",
            "notes": "Use precinct finder on NYPD site for local contact."
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Brooklyn Public Library – Central Library",
            "address": "10 Grand Army Plaza, Brooklyn, NY 11238",
            "phone": "(718) 230-2100",
            "website": "https://www.bklynlibrary.org/",
            "map": "https://maps.google.com/?q=10+Grand+Army+Plaza,+Brooklyn,+NY+11238"
          }
        ]
      }
    ]
  },

  "ny/queens-county": {
    "city": "Queens County",
    "state": "New York",
    "sections": [
      {
        "category": "County/Borough Government",
        "items": [
          {
            "name": "Queens Borough Hall",
            "address": "120-55 Queens Blvd, Kew Gardens, NY 11424",
            "phone": "(718) 286-3000",
            "website": "https://queensbp.org/",
            "map": "https://maps.google.com/?q=120-55+Queens+Blvd,+Kew+Gardens,+NY+11424"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "NYPD – Queens Borough (Multiple Precincts)",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (Info) • 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038",
            "notes": "Use precinct finder for local contact."
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Queens Public Library – Central Library",
            "address": "89-11 Merrick Blvd, Jamaica, NY 11432",
            "phone": "(718) 990-0700",
            "website": "https://www.queenslibrary.org/",
            "map": "https://maps.google.com/?q=89-11+Merrick+Blvd,+Jamaica,+NY+11432"
          }
        ]
      }
    ]
  },

  "ny/bronx-county": {
    "city": "Bronx County",
    "state": "New York",
    "sections": [
      {
        "category": "County/Borough Government",
        "items": [
          {
            "name": "Bronx County Building / Borough Hall",
            "address": "851 Grand Concourse, Bronx, NY 10451",
            "phone": "(718) 590-3500",
            "website": "https://bronxboropres.nyc.gov/",
            "map": "https://maps.google.com/?q=851+Grand+Concourse,+Bronx,+NY+10451"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "NYPD – Bronx Borough (Multiple Precincts)",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (Info) • 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York Public Library – Bronx Library Center",
            "address": "310 E Kingsbridge Rd, Bronx, NY 10458",
            "phone": "(718) 579-4244",
            "website": "https://www.nypl.org/locations/bronx-library-center",
            "map": "https://maps.google.com/?q=310+E+Kingsbridge+Rd,+Bronx,+NY+10458"
          }
        ]
      }
    ]
  },

  "ny/richmond-county": {
    "city": "Richmond County (Staten Island)",
    "state": "New York",
    "sections": [
      {
        "category": "County/Borough Government",
        "items": [
          {
            "name": "Staten Island Borough Hall",
            "address": "10 Richmond Ter, Staten Island, NY 10301",
            "phone": "(718) 816-2000",
            "website": "https://www.statenislandusa.com/",
            "map": "https://maps.google.com/?q=10+Richmond+Ter,+Staten+Island,+NY+10301"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "NYPD – Staten Island (Multiple Precincts)",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (Info) • 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York Public Library – St. George Library Center",
            "address": "5 Central Ave, Staten Island, NY 10301",
            "phone": "(718) 442-8560",
            "website": "https://www.nypl.org/locations/st-george-library-center",
            "map": "https://maps.google.com/?q=5+Central+Ave,+Staten+Island,+NY+10301"
          }
        ]
      }
    ]
  },

  "ny/nassau-county": {
    "city": "Nassau County",
    "state": "New York",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Nassau County Executive Offices",
            "address": "1550 Franklin Ave, Mineola, NY 11501",
            "phone": "(516) 571-3131",
            "website": "https://www.nassaucountyny.gov/",
            "map": "https://maps.google.com/?q=1550+Franklin+Ave,+Mineola,+NY+11501"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "Nassau County Police Department (HQ)",
            "address": "1490 Franklin Ave, Mineola, NY 11501",
            "phone": "(516) 573-8800 (Non-Emergency) • 911 (Emergency)",
            "website": "https://www.pdcn.org/",
            "map": "https://maps.google.com/?q=1490+Franklin+Ave,+Mineola,+NY+11501"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Nassau Library System",
            "address": "900 Jerusalem Ave, Uniondale, NY 11553",
            "phone": "(516) 292-8920",
            "website": "https://www.nassaulibrary.org/",
            "map": "https://maps.google.com/?q=900+Jerusalem+Ave,+Uniondale,+NY+11553"
          }
        ]
      }
    ]
  },

  "ny/suffolk-county": {
    "city": "Suffolk County",
    "state": "New York",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "H. Lee Dennison Building (County Executive Offices)",
            "address": "100 Veterans Memorial Hwy, Hauppauge, NY 11788",
            "phone": "(631) 853-4000",
            "website": "https://www.suffolkcountyny.gov/",
            "map": "https://maps.google.com/?q=100+Veterans+Memorial+Hwy,+Hauppauge,+NY+11788"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "Suffolk County Police Department (HQ)",
            "address": "30 Yaphank Ave, Yaphank, NY 11980",
            "phone": "(631) 852-6000 (Non-Emergency) • 911 (Emergency)",
            "website": "https://suffolkpd.org/",
            "map": "https://maps.google.com/?q=30+Yaphank+Ave,+Yaphank,+NY+11980"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Suffolk Cooperative Library System",
            "address": "627 N Sunrise Service Rd, Bellport, NY 11713",
            "phone": "(631) 286-1600",
            "website": "https://scls.suffolk.lib.ny.us/",
            "map": "https://maps.google.com/?q=627+N+Sunrise+Service+Rd,+Bellport,+NY+11713"
          }
        ]
      }
    ]
  },

  "ny/westchester-county": {
    "city": "Westchester County",
    "state": "New York",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Michaelian Office Building (County Executive)",
            "address": "148 Martine Ave, White Plains, NY 10601",
            "phone": "(914) 995-2900",
            "website": "https://www.westchestercountyny.gov/",
            "map": "https://maps.google.com/?q=148+Martine+Ave,+White+Plains,+NY+10601"
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "Westchester County Department of Public Safety",
            "address": "1 Saw Mill River Pkwy, Hawthorne, NY 10532",
            "phone": "(914) 864-7700 (Non-Emergency) • 911 (Emergency)",
            "website": "https://publicsafety.westchestergov.com/",
            "map": "https://maps.google.com/?q=1+Saw+Mill+River+Pkwy,+Hawthorne,+NY+10532"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Westchester Library System",
            "address": "570 Taxter Rd, Suite 400, Elmsford, NY 10523",
            "phone": "(914) 231-3227",
            "website": "https://www.westchesterlibraries.org/",
            "map": "https://maps.google.com/?q=570+Taxter+Rd,+Elmsford,+NY+10523"
          }
        ]
      }
    ]
  },
  "ct/state": {
    "city": "Connecticut",
    "state": "Connecticut",
    "sections": [
      {
        "category": "State Government",
        "items": [
          {
            "name": "Connecticut State Capitol",
            "address": "210 Capitol Ave, Hartford, CT 06106",
            "phone": "(860) 240-0100",
            "website": "https://portal.ct.gov/",
            "map": "https://maps.google.com/?q=210+Capitol+Ave,+Hartford,+CT+06106",
            "people": [
              { "title": "Governor", "name": "Ned Lamont" },
              { "title": "Lt. Governor", "name": "Susan Bysiewicz" }
            ]
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Connecticut State Library",
            "address": "231 Capitol Ave, Hartford, CT 06106",
            "phone": "(860) 757-6500",
            "website": "https://ctstatelibrary.org/",
            "map": "https://maps.google.com/?q=231+Capitol+Ave,+Hartford,+CT+06106"
          }
        ]
      },
      {
        "category": "University",
        "items": [
          {
            "name": "University of Connecticut (UConn)",
            "address": "2131 Hillside Rd, Storrs, CT 06269",
            "phone": "(860) 486-2000",
            "website": "https://uconn.edu/",
            "map": "https://maps.google.com/?q=2131+Hillside+Rd,+Storrs,+CT+06269"
          }
        ]
      }
    ]
  },

  "ct/fairfield-county": {
    "city": "Fairfield County",
    "state": "Connecticut",
    "sections": [
      {
        "category": "County Government",
        "items": [
          {
            "name": "Fairfield County (Note: No County Government — functions handled at town level)",
            "address": "N/A",
            "phone": "N/A",
            "website": "https://portal.ct.gov/",
            "map": null,
            "notes": "Connecticut abolished county government in 1960; services managed by individual towns and state."
          }
        ]
      },
      {
        "category": "Courts",
        "items": [
          {
            "name": "Stamford Superior Court",
            "address": "123 Hoyt St, Stamford, CT 06905",
            "phone": "(203) 965-5308",
            "website": "https://jud.ct.gov/directory/courtlocations.htm",
            "map": "https://maps.google.com/?q=123+Hoyt+St,+Stamford,+CT+06905"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Ferguson Library (Stamford)",
            "address": "1 Public Library Plaza, Stamford, CT 06901",
            "phone": "(203) 964-1000",
            "website": "https://fergusonlibrary.org/",
            "map": "https://maps.google.com/?q=1+Public+Library+Plaza,+Stamford,+CT+06901"
          },
          {
            "name": "Greenwich Library",
            "address": "101 W Putnam Ave, Greenwich, CT 06830",
            "phone": "(203) 622-7900",
            "website": "https://www.greenwichlibrary.org/",
            "map": "https://maps.google.com/?q=101+W+Putnam+Ave,+Greenwich,+CT+06830"
          }
        ]
      },
      {
        "category": "University",
        "items": [
          {
            "name": "University of Connecticut – Stamford Campus",
            "address": "1 University Pl, Stamford, CT 06901",
            "phone": "(203) 251-8400",
            "website": "https://stamford.uconn.edu/",
            "map": "https://maps.google.com/?q=1+University+Pl,+Stamford,+CT+06901"
          },
          {
            "name": "Sacred Heart University",
            "address": "5151 Park Ave, Fairfield, CT 06825",
            "phone": "(203) 371-7999",
            "website": "https://www.sacredheart.edu/",
            "map": "https://maps.google.com/?q=5151+Park+Ave,+Fairfield,+CT+06825"
          }
        ]
      }
    ]
  },
  "nj/east-orange": {
    "city": "East Orange",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "City of East Orange",
            "address": "44 City Hall Plaza, East Orange, NJ 07018",
            "phone": "(973) 266-5100",
            "website": "https://eastorange-nj.gov/",
            "map": "https://maps.google.com/?q=44+City+Hall+Plaza,+East+Orange,+NJ+07018",
            "people": [
              { "title": "Mayor", "name": "Ted R. Green", "phone": "(973) 266-5100" }
            ]
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "East Orange Public Library",
            "address": "21 S Arlington Ave, East Orange, NJ 07018",
            "phone": "(973) 266-5600",
            "website": "https://www.eopl.org/",
            "map": "https://maps.google.com/?q=21+S+Arlington+Ave,+East+Orange,+NJ+07018"
          }
        ]
      }
    ]
  },

  "nj/montclair": {
    "city": "Montclair",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Town Hall",
        "items": [
          {
            "name": "Montclair Municipal Building",
            "address": "205 Claremont Ave, Montclair, NJ 07042",
            "phone": "(973) 509-4951",
            "website": "https://www.montclairnjusa.org/",
            "map": "https://maps.google.com/?q=205+Claremont+Ave,+Montclair,+NJ+07042"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Montclair Public Library",
            "address": "50 S Fullerton Ave, Montclair, NJ 07042",
            "phone": "(973) 744-0500",
            "website": "https://www.montclairlibrary.org/",
            "map": "https://maps.google.com/?q=50+S+Fullerton+Ave,+Montclair,+NJ+07042"
          }
        ]
      }
    ]
  },

  "nj/paterson": {
    "city": "Paterson",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "City of Paterson",
            "address": "155 Market St, Paterson, NJ 07505",
            "phone": "(973) 321-1600",
            "website": "https://www.patersonnj.gov/",
            "map": "https://maps.google.com/?q=155+Market+St,+Paterson,+NJ+07505",
            "people": [
              { "title": "Mayor", "name": "Andre Sayegh", "phone": "(973) 321-1600" }
            ]
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Paterson Free Public Library",
            "address": "250 Broadway, Paterson, NJ 07501",
            "phone": "(973) 321-1223",
            "website": "https://patersonpl.org/",
            "map": "https://maps.google.com/?q=250+Broadway,+Paterson,+NJ+07501"
          }
        ]
      }
    ]
  },

  "nj/hackensack": {
    "city": "Hackensack",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "Hackensack City Hall",
            "address": "65 Central Ave, Hackensack, NJ 07601",
            "phone": "(201) 646-3900",
            "website": "https://www.hackensack.org/",
            "map": "https://maps.google.com/?q=65+Central+Ave,+Hackensack,+NJ+07601"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Johnson Free Public Library",
            "address": "274 Main St, Hackensack, NJ 07601",
            "phone": "(201) 343-4169",
            "website": "https://hackensacklibrary.org/",
            "map": "https://maps.google.com/?q=274+Main+St,+Hackensack,+NJ+07601"
          }
        ]
      }
    ]
  },

  "nj/teaneck": {
    "city": "Teaneck",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Township Government",
        "items": [
          {
            "name": "Teaneck Municipal Building",
            "address": "818 Teaneck Rd, Teaneck, NJ 07666",
            "phone": "(201) 837-1600",
            "website": "https://www.teanecknj.gov/",
            "map": "https://maps.google.com/?q=818+Teaneck+Rd,+Teaneck,+NJ+07666"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Teaneck Public Library",
            "address": "840 Teaneck Rd, Teaneck, NJ 07666",
            "phone": "(201) 837-4171",
            "website": "https://teanecklibrary.org/",
            "map": "https://maps.google.com/?q=840+Teaneck+Rd,+Teaneck,+NJ+07666"
          }
        ]
      }
    ]
  },

  "nj/ridgewood": {
    "city": "Ridgewood",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Village Government",
        "items": [
          {
            "name": "Village of Ridgewood",
            "address": "131 N Maple Ave, Ridgewood, NJ 07451",
            "phone": "(201) 670-5500",
            "website": "https://www.ridgewoodnj.net/",
            "map": "https://maps.google.com/?q=131+N+Maple+Ave,+Ridgewood,+NJ+07451"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Ridgewood Public Library",
            "address": "125 N Maple Ave, Ridgewood, NJ 07450",
            "phone": "(201) 670-5600",
            "website": "https://ridgewoodlibrary.org/",
            "map": "https://maps.google.com/?q=125+N+Maple+Ave,+Ridgewood,+NJ+07450"
          }
        ]
      }
    ]
  },

  "nj/paramus": {
    "city": "Paramus",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Borough Hall",
        "items": [
          {
            "name": "Paramus Borough Hall",
            "address": "1 Jockish Square, Paramus, NJ 07652",
            "phone": "(201) 265-2100",
            "website": "https://www.paramusborough.org/",
            "map": "https://maps.google.com/?q=1+Jockish+Square,+Paramus,+NJ+07652"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Paramus Public Library",
            "address": "116 E Century Rd, Paramus, NJ 07652",
            "phone": "(201) 599-1305",
            "website": "https://www.paramuslibrary.org/",
            "map": "https://maps.google.com/?q=116+E+Century+Rd,+Paramus,+NJ+07652"
          }
        ]
      }
    ]
  },

  "nj/clifton": {
    "city": "Clifton",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "Clifton City Hall",
            "address": "900 Clifton Ave, Clifton, NJ 07013",
            "phone": "(973) 470-5800",
            "website": "https://cliftonnj.org/",
            "map": "https://maps.google.com/?q=900+Clifton+Ave,+Clifton,+NJ+07013"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Clifton Public Library",
            "address": "292 Piaget Ave, Clifton, NJ 07011",
            "phone": "(973) 772-5500",
            "website": "https://cliftonpl.org/",
            "map": "https://maps.google.com/?q=292+Piaget+Ave,+Clifton,+NJ+07011"
          }
        ]
      }
    ]
  },

  "nj/englewood": {
    "city": "Englewood",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "Englewood City Hall",
            "address": "2-10 N Van Brunt St, Englewood, NJ 07631",
            "phone": "(201) 871-6630",
            "website": "https://www.cityofenglewood.org/",
            "map": "https://maps.google.com/?q=2-10+N+Van+Brunt+St,+Englewood,+NJ+07631"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Englewood Public Library",
            "address": "31 Engle St, Englewood, NJ 07631",
            "phone": "(201) 568-2215",
            "website": "https://www.englewoodlibrary.org/",
            "map": "https://maps.google.com/?q=31+Engle+St,+Englewood,+NJ+07631"
          }
        ]
      }
    ]
  },

  "nj/fort-lee": {
    "city": "Fort Lee",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Municipal Government",
        "items": [
          {
            "name": "Fort Lee Borough Hall",
            "address": "309 Main St, Fort Lee, NJ 07024",
            "phone": "(201) 592-3500",
            "website": "https://www.fortleenj.org/",
            "map": "https://maps.google.com/?q=309+Main+St,+Fort+Lee,+NJ+07024"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Fort Lee Public Library",
            "address": "320 Main St, Fort Lee, NJ 07024",
            "phone": "(201) 592-3614",
            "website": "https://fortleelibrary.org/",
            "map": "https://maps.google.com/?q=320+Main+St,+Fort+Lee,+NJ+07024"
          }
        ]
      }
    ]
  },

  "nj/passaic": {
    "city": "Passaic",
    "state": "New Jersey",
    "sections": [
      {
        "category": "City Hall",
        "items": [
          {
            "name": "City of Passaic",
            "address": "330 Passaic St, Passaic, NJ 07055",
            "phone": "(973) 365-5500",
            "website": "https://www.cityofpassaic.com/",
            "map": "https://maps.google.com/?q=330+Passaic+St,+Passaic,+NJ+07055"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Passaic Public Library",
            "address": "195 Gregory Ave, Passaic, NJ 07055",
            "phone": "(973) 779-0474",
            "website": "https://www.passaicpubliclibrary.org/",
            "map": "https://maps.google.com/?q=195+Gregory+Ave,+Passaic,+NJ+07055"
          }
        ]
      }
    ]
  },

  "nj/bloomfield": {
    "city": "Bloomfield",
    "state": "New Jersey",
    "sections": [
      {
        "category": "Township Government",
        "items": [
          {
            "name": "Bloomfield Municipal Building",
            "address": "1 Municipal Plaza, Bloomfield, NJ 07003",
            "phone": "(973) 680-4000",
            "website": "https://www.bloomfieldtwpnj.com/",
            "map": "https://maps.google.com/?q=1+Municipal+Plaza,+Bloomfield,+NJ+07003"
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "Bloomfield Public Library",
            "address": "90 Broad St, Bloomfield, NJ 07003",
            "phone": "(973) 566-6200",
            "website": "https://www.bplnj.org/",
            "map": "https://maps.google.com/?q=90+Broad+St,+Bloomfield,+NJ+07003"
          }
        ]
      }
    ]
  },
  "ny/new-york-county": {
    "city": "New York County",
    "state": "New York",
    "sections": [
      {
        "category": "Borough Government",
        "items": [
          {
            "name": "Office of the Manhattan Borough President",
            "address": "1 Centre St, 19th Floor, New York, NY 10007",
            "phone": "(212) 669-8300",
            "website": "https://manhattanbp.nyc.gov/",
            "map": "https://maps.google.com/?q=1+Centre+St,+New+York,+NY+10007",
            "people": [
              { "title": "Borough President", "name": "Mark Levine", "phone": "(212) 669-8300" }
            ]
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "New York City Police Department (NYPD) Headquarters",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (General), 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038",
            "notes": "Manhattan is served by multiple precincts; NYPD site has a precinct locator."
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York Public Library – Stephen A. Schwarzman Building",
            "address": "476 5th Ave, New York, NY 10018",
            "phone": "(917) 275-6975",
            "website": "https://www.nypl.org/locations/schwarzman",
            "map": "https://maps.google.com/?q=476+5th+Ave,+New+York,+NY+10018"
          },
          {
            "name": "New York Public Library – Jefferson Market Branch",
            "address": "425 6th Ave, New York, NY 10011",
            "phone": "(212) 243-4334",
            "website": "https://www.nypl.org/locations/jefferson-market",
            "map": "https://maps.google.com/?q=425+6th+Ave,+New+York,+NY+10011"
          }
        ]
      },
      {
        "category": "Public Schools",
        "items": [
          {
            "name": "NYC Department of Education – District 2 (Manhattan)",
            "address": "333 7th Ave, New York, NY 10001",
            "phone": "(212) 356-3500",
            "website": "https://www.schools.nyc.gov/",
            "map": "https://maps.google.com/?q=333+7th+Ave,+New+York,+NY+10001"
          }
        ]
      },
      {
        "category": "Universities",
        "items": [
          {
            "name": "Columbia University",
            "address": "116th St & Broadway, New York, NY 10027",
            "phone": "(212) 854-1754",
            "website": "https://www.columbia.edu/",
            "map": "https://maps.google.com/?q=116th+St+and+Broadway,+New+York,+NY+10027"
          },
          {
            "name": "New York University (NYU)",
            "address": "70 Washington Square S, New York, NY 10012",
            "phone": "(212) 998-1212",
            "website": "https://www.nyu.edu/",
            "map": "https://maps.google.com/?q=70+Washington+Square+S,+New+York,+NY+10012"
          }
        ]
      }
    ]
  },
  "ny/new-york-county": {
    "city": "New York County",
    "state": "New York",
    "sections": [
      {
        "category": "Borough Government",
        "items": [
          {
            "name": "Office of the Manhattan Borough President",
            "address": "1 Centre St, 19th Floor, New York, NY 10007",
            "phone": "(212) 669-8300",
            "website": "https://manhattanbp.nyc.gov/",
            "map": "https://maps.google.com/?q=1+Centre+St,+New+York,+NY+10007",
            "people": [
              { "title": "Borough President", "name": "Mark Levine", "phone": "(212) 669-8300" }
            ]
          }
        ]
      },
      {
        "category": "Police Services",
        "items": [
          {
            "name": "New York City Police Department (NYPD) Headquarters",
            "address": "1 Police Plaza, New York, NY 10038",
            "phone": "(646) 610-5000 (General), 911 (Emergency)",
            "website": "https://www.nyc.gov/nypd",
            "map": "https://maps.google.com/?q=1+Police+Plaza,+New+York,+NY+10038",
            "notes": "Manhattan is served by multiple precincts; NYPD site has a precinct locator."
          }
        ]
      },
      {
        "category": "Library",
        "items": [
          {
            "name": "New York Public Library – Stephen A. Schwarzman Building",
            "address": "476 5th Ave, New York, NY 10018",
            "phone": "(917) 275-6975",
            "website": "https://www.nypl.org/locations/schwarzman",
            "map": "https://maps.google.com/?q=476+5th+Ave,+New+York,+NY+10018"
          },
          {
            "name": "New York Public Library – Jefferson Market Branch",
            "address": "425 6th Ave, New York, NY 10011",
            "phone": "(212) 243-4334",
            "website": "https://www.nypl.org/locations/jefferson-market",
            "map": "https://maps.google.com/?q=425+6th+Ave,+New+York,+NY+10011"
          }
        ]
      },
      {
        "category": "Public Schools",
        "items": [
          {
            "name": "NYC Department of Education – District 2 (Manhattan)",
            "address": "333 7th Ave, New York, NY 10001",
            "phone": "(212) 356-3500",
            "website": "https://www.schools.nyc.gov/",
            "map": "https://maps.google.com/?q=333+7th+Ave,+New+York,+NY+10001"
          }
        ]
      },
      {
        "category": "Universities",
        "items": [
          {
            "name": "Columbia University",
            "address": "116th St & Broadway, New York, NY 10027",
            "phone": "(212) 854-1754",
            "website": "https://www.columbia.edu/",
            "map": "https://maps.google.com/?q=116th+St+and+Broadway,+New+York,+NY+10027"
          },
          {
            "name": "New York University (NYU)",
            "address": "70 Washington Square S, New York, NY 10012",
            "phone": "(212) 998-1212",
            "website": "https://www.nyu.edu/",
            "map": "https://maps.google.com/?q=70+Washington+Square+S,+New+York,+NY+10012"
          }
        ]
      }
    ]
  }

};

export function contactKey(state, city) {
  const norm = (s) =>
    String(s || "").trim().toLowerCase().replace(/\s+/g, "-");
  return `${norm(state)}/${norm(city)}`;
}